var items = {
  "block.minecraft.acacia_button": "Кнопка з акацыі",
  "block.minecraft.acacia_door": "Дзверы з акацыі",
  "block.minecraft.acacia_fence": "Плот з акацыі",
  "block.minecraft.acacia_fence_gate": "Брамка з акацыі",
  "block.minecraft.acacia_hanging_sign": "Падвесная шыльда з акацыі",
  "block.minecraft.acacia_leaves": "Лісце акацыі",
  "block.minecraft.acacia_log": "Бервяно акацыі",
  "block.minecraft.acacia_planks": "Дошкі з акацыі",
  "block.minecraft.acacia_pressure_plate": "Націскная пліта з акацыі",
  "block.minecraft.acacia_sapling": "Саджанец акацыі",
  "block.minecraft.acacia_shelf": "Паліца з акацыі",
  "block.minecraft.acacia_sign": "Шыльда з акацыі",
  "block.minecraft.acacia_slab": "Пліта з акацыі",
  "block.minecraft.acacia_stairs": "Прыступкі з акацыі",
  "block.minecraft.acacia_trapdoor": "Люк з акацыі",
  "block.minecraft.acacia_wall_hanging_sign": "Насценная падвесная шыльда з акацыі",
  "block.minecraft.acacia_wall_sign": "Насценная шыльда з акацыі",
  "block.minecraft.acacia_wood": "Драўніна акацыі",
  "block.minecraft.activator_rail": "Актывуючыя рэйкі",
  "block.minecraft.air": "Паветра",
  "block.minecraft.allium": "Цыбуля",
  "block.minecraft.amethyst_block": "Аметыставы блок",
  "block.minecraft.amethyst_cluster": "Аметыставая друза",
  "block.minecraft.ancient_debris": "Старажытныя рэшткі",
  "block.minecraft.andesite": "Андэзіт",
  "block.minecraft.andesite_slab": "Пліта з андэзіту",
  "block.minecraft.andesite_stairs": "Прыступкі з андэзіту",
  "block.minecraft.andesite_wall": "Сцяна з андэзіту",
  "block.minecraft.anvil": "Кавадла",
  "block.minecraft.attached_melon_stem": "Прырослае сцябло кавуна",
  "block.minecraft.attached_pumpkin_stem": "Прырослае сцябло гарбуза",
  "block.minecraft.azalea": "Азалія",
  "block.minecraft.azalea_leaves": "Лісце азаліі",
  "block.minecraft.azure_bluet": "Хаўстонія блакітная",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбукавы блок",
  "block.minecraft.bamboo_button": "Бамбукавая кнопка",
  "block.minecraft.bamboo_door": "Бамбукавыя дзверы",
  "block.minecraft.bamboo_fence": "Бамбукавы плот",
  "block.minecraft.bamboo_fence_gate": "Бамбукавая брамка",
  "block.minecraft.bamboo_hanging_sign": "Бамбукавая падвесная шыльда",
  "block.minecraft.bamboo_mosaic": "Бамбукавая мазаіка",
  "block.minecraft.bamboo_mosaic_slab": "Пліта з бамбукавай мазаікі",
  "block.minecraft.bamboo_mosaic_stairs": "Прыступкі з бамбукавай мазаікі",
  "block.minecraft.bamboo_planks": "Бамбукавыя дошкі",
  "block.minecraft.bamboo_pressure_plate": "Бамбукавая націскная пліта",
  "block.minecraft.bamboo_sapling": "Парастак бамбуку",
  "block.minecraft.bamboo_shelf": "Бамбукавая паліца",
  "block.minecraft.bamboo_sign": "Бамбукавая шыльда",
  "block.minecraft.bamboo_slab": "Бамбукавая пліта",
  "block.minecraft.bamboo_stairs": "Бамбукавыя прыступкі",
  "block.minecraft.bamboo_trapdoor": "Бамбукавы люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбукавая насценная падвесная шыльда",
  "block.minecraft.bamboo_wall_sign": "Бамбукавая насценная шыльда",
  "block.minecraft.banner.base.black": "Цалкам чорнае поле",
  "block.minecraft.banner.base.blue": "Цалкам сіняе поле",
  "block.minecraft.banner.base.brown": "Цалкам карычневае поле",
  "block.minecraft.banner.base.cyan": "Цалкам бірузовае поле",
  "block.minecraft.banner.base.gray": "Цалкам шэрае поле",
  "block.minecraft.banner.base.green": "Цалкам зялёнае поле",
  "block.minecraft.banner.base.light_blue": "Цалкам блакітнае поле",
  "block.minecraft.banner.base.light_gray": "Цалкам светла-шэрае поле",
  "block.minecraft.banner.base.lime": "Цалкам лаймавае поле",
  "block.minecraft.banner.base.magenta": "Цалкам пурпурнае поле",
  "block.minecraft.banner.base.orange": "Цалкам аранжавае поле",
  "block.minecraft.banner.base.pink": "Цалкам ружовае поле",
  "block.minecraft.banner.base.purple": "Цалкам фіялетавае поле",
  "block.minecraft.banner.base.red": "Цалкам чырвонае поле",
  "block.minecraft.banner.base.white": "Цалкам белае поле",
  "block.minecraft.banner.base.yellow": "Цалкам жоўтае поле",
  "block.minecraft.banner.border.black": "Чорная ліштва",
  "block.minecraft.banner.border.blue": "Сіняя ліштва",
  "block.minecraft.banner.border.brown": "Карычневая ліштва",
  "block.minecraft.banner.border.cyan": "Бірузовая ліштва",
  "block.minecraft.banner.border.gray": "Шэрая ліштва",
  "block.minecraft.banner.border.green": "Зялёная ліштва",
  "block.minecraft.banner.border.light_blue": "Блакітная ліштва",
  "block.minecraft.banner.border.light_gray": "Светла-шэрая ліштва",
  "block.minecraft.banner.border.lime": "Лаймавая ліштва",
  "block.minecraft.banner.border.magenta": "Пурпурная ліштва",
  "block.minecraft.banner.border.orange": "Аранжавая ліштва",
  "block.minecraft.banner.border.pink": "Ружовая ліштва",
  "block.minecraft.banner.border.purple": "Фіялетавая ліштва",
  "block.minecraft.banner.border.red": "Чырвоная ліштва",
  "block.minecraft.banner.border.white": "Белая ліштва",
  "block.minecraft.banner.border.yellow": "Жоўтая ліштва",
  "block.minecraft.banner.bricks.black": "Чорны мур",
  "block.minecraft.banner.bricks.blue": "Сіні мур",
  "block.minecraft.banner.bricks.brown": "Карычневы мур",
  "block.minecraft.banner.bricks.cyan": "Бірузовы мур",
  "block.minecraft.banner.bricks.gray": "Шэры мур",
  "block.minecraft.banner.bricks.green": "Зялёны мур",
  "block.minecraft.banner.bricks.light_blue": "Блакітны мур",
  "block.minecraft.banner.bricks.light_gray": "Светла-шэры мур",
  "block.minecraft.banner.bricks.lime": "Лаймавы мур",
  "block.minecraft.banner.bricks.magenta": "Пурпурны мур",
  "block.minecraft.banner.bricks.orange": "Аранжавы мур",
  "block.minecraft.banner.bricks.pink": "Ружовы мур",
  "block.minecraft.banner.bricks.purple": "Фіялетавы мур",
  "block.minecraft.banner.bricks.red": "Чырвоны мур",
  "block.minecraft.banner.bricks.white": "Белы мур",
  "block.minecraft.banner.bricks.yellow": "Жоўты мур",
  "block.minecraft.banner.circle.black": "Чорны круг",
  "block.minecraft.banner.circle.blue": "Сіні круг",
  "block.minecraft.banner.circle.brown": "Карычневы круг",
  "block.minecraft.banner.circle.cyan": "Бірузовы круг",
  "block.minecraft.banner.circle.gray": "Шэры круг",
  "block.minecraft.banner.circle.green": "Зялёны круг",
  "block.minecraft.banner.circle.light_blue": "Блакітны круг",
  "block.minecraft.banner.circle.light_gray": "Светла-шэры круг",
  "block.minecraft.banner.circle.lime": "Лаймавы круг",
  "block.minecraft.banner.circle.magenta": "Пурпурны круг",
  "block.minecraft.banner.circle.orange": "Аранжавы круг",
  "block.minecraft.banner.circle.pink": "Ружовы круг",
  "block.minecraft.banner.circle.purple": "Фіялетавы круг",
  "block.minecraft.banner.circle.red": "Чырвоны круг",
  "block.minecraft.banner.circle.white": "Белы круг",
  "block.minecraft.banner.circle.yellow": "Жоўты круг",
  "block.minecraft.banner.creeper.black": "Чорная фігура крыпера",
  "block.minecraft.banner.creeper.blue": "Сіняя фігура крыпера",
  "block.minecraft.banner.creeper.brown": "Карычневая фігура крыпера",
  "block.minecraft.banner.creeper.cyan": "Бірузовая фігура крыпера",
  "block.minecraft.banner.creeper.gray": "Шэрая фігура крыпера",
  "block.minecraft.banner.creeper.green": "Зялёная фігура крыпера",
  "block.minecraft.banner.creeper.light_blue": "Блакітная фігура крыпера",
  "block.minecraft.banner.creeper.light_gray": "Светла-шэрая фігура крыпера",
  "block.minecraft.banner.creeper.lime": "Лаймавая фігура крыпера",
  "block.minecraft.banner.creeper.magenta": "Пурпурная фігура крыпера",
  "block.minecraft.banner.creeper.orange": "Аранжавая фігура крыпера",
  "block.minecraft.banner.creeper.pink": "Ружовая фігура крыпера",
  "block.minecraft.banner.creeper.purple": "Фіялетавая фігура крыпера",
  "block.minecraft.banner.creeper.red": "Чырвоная фігура крыпера",
  "block.minecraft.banner.creeper.white": "Белая фігура крыпера",
  "block.minecraft.banner.creeper.yellow": "Жоўтая фігура крыпера",
  "block.minecraft.banner.cross.black": "Чорны андрэеўскі крыж",
  "block.minecraft.banner.cross.blue": "Сіні андрэеўскі крыж",
  "block.minecraft.banner.cross.brown": "Карычневы андрэеўскі крыж",
  "block.minecraft.banner.cross.cyan": "Бірузовы андрэеўскі крыж",
  "block.minecraft.banner.cross.gray": "Шэры андрэеўскі крыж",
  "block.minecraft.banner.cross.green": "Зялёны андрэеўскі крыж",
  "block.minecraft.banner.cross.light_blue": "Блакітны андрэеўскі крыж",
  "block.minecraft.banner.cross.light_gray": "Светла-шэры андрэеўскі крыж",
  "block.minecraft.banner.cross.lime": "Лаймавы андрэеўскі крыж",
  "block.minecraft.banner.cross.magenta": "Пурпурны андрэеўскі крыж",
  "block.minecraft.banner.cross.orange": "Аранжавы андрэеўскі крыж",
  "block.minecraft.banner.cross.pink": "Ружовы андрэеўскі крыж",
  "block.minecraft.banner.cross.purple": "Фіялетавы андрэеўскі крыж",
  "block.minecraft.banner.cross.red": "Чырвоны андрэеўскі крыж",
  "block.minecraft.banner.cross.white": "Белы андрэеўскі крыж",
  "block.minecraft.banner.cross.yellow": "Жоўты андрэеўскі крыж",
  "block.minecraft.banner.curly_border.black": "Чорная зубчастая ліштва",
  "block.minecraft.banner.curly_border.blue": "Сіняя зубчастая ліштва",
  "block.minecraft.banner.curly_border.brown": "Карычневая зубчастая ліштва",
  "block.minecraft.banner.curly_border.cyan": "Бірузовая зубчастая ліштва",
  "block.minecraft.banner.curly_border.gray": "Шэрая зубчастая ліштва",
  "block.minecraft.banner.curly_border.green": "Зялёная зубчастая ліштва",
  "block.minecraft.banner.curly_border.light_blue": "Блакітная зубчастая ліштва",
  "block.minecraft.banner.curly_border.light_gray": "Светла-шэрая зубчастая ліштва",
  "block.minecraft.banner.curly_border.lime": "Лаймавая зубчастая ліштва",
  "block.minecraft.banner.curly_border.magenta": "Пурпурная зубчастая ліштва",
  "block.minecraft.banner.curly_border.orange": "Аранжавая зубчастая ліштва",
  "block.minecraft.banner.curly_border.pink": "Ружовая зубчастая ліштва",
  "block.minecraft.banner.curly_border.purple": "Фіялетавая зубчастая ліштва",
  "block.minecraft.banner.curly_border.red": "Чырвоная зубчастая ліштва",
  "block.minecraft.banner.curly_border.white": "Белая зубчастая ліштва",
  "block.minecraft.banner.curly_border.yellow": "Жоўтая зубчастая ліштва",
  "block.minecraft.banner.diagonal_left.black": "Чорная верхняя левая палова",
  "block.minecraft.banner.diagonal_left.blue": "Сіняя верхняя левая палова",
  "block.minecraft.banner.diagonal_left.brown": "Карычневая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.cyan": "Бірузовая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.gray": "Шэрая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.green": "Зялёная верхняя левая палова",
  "block.minecraft.banner.diagonal_left.light_blue": "Блакітная верхняя левая палова",
  "block.minecraft.banner.diagonal_left.light_gray": "Светла-шэрая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.lime": "Лаймавая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.magenta": "Пурпурная верхняя левая палова",
  "block.minecraft.banner.diagonal_left.orange": "Аранжавая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.pink": "Ружовая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.purple": "Фіялетавая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.red": "Чырвоная верхняя левая палова",
  "block.minecraft.banner.diagonal_left.white": "Белая верхняя левая палова",
  "block.minecraft.banner.diagonal_left.yellow": "Жоўтая верхняя левая палова",
  "block.minecraft.banner.diagonal_right.black": "Чорная верхняя правая палова",
  "block.minecraft.banner.diagonal_right.blue": "Сіняя верхняя правая палова",
  "block.minecraft.banner.diagonal_right.brown": "Карычневая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.cyan": "Бірузовая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.gray": "Шэрая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.green": "Зялёная верхняя правая палова",
  "block.minecraft.banner.diagonal_right.light_blue": "Блакітная верхняя правая палова",
  "block.minecraft.banner.diagonal_right.light_gray": "Светла-шэрая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.lime": "Лаймавая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.magenta": "Пурпурная верхняя правая палова",
  "block.minecraft.banner.diagonal_right.orange": "Аранжавая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.pink": "Ружовая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.purple": "Фіялетавая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.red": "Чырвоная верхняя правая палова",
  "block.minecraft.banner.diagonal_right.white": "Белая верхняя правая палова",
  "block.minecraft.banner.diagonal_right.yellow": "Жоўтая верхняя правая палова",
  "block.minecraft.banner.diagonal_up_left.black": "Чорная ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.blue": "Сіняя ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.brown": "Карычневая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.cyan": "Бірузовая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.gray": "Шэрая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.green": "Зялёная ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Блакітная ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Светла-шэрая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.lime": "Лаймавая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.magenta": "Пурпурная ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.orange": "Аранжавая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.pink": "Ружовая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.purple": "Фіялетавая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.red": "Чырвоная ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.white": "Белая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жоўтая ніжняя левая палова",
  "block.minecraft.banner.diagonal_up_right.black": "Чорная ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.blue": "Сіняя ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.brown": "Карычневая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.cyan": "Бірузовая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.gray": "Шэрая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.green": "Зялёная ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Блакітная ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Светла-шэрая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.lime": "Лаймавая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.magenta": "Пурпурная ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.orange": "Аранжавая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.pink": "Ружовая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.purple": "Фіялетавая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.red": "Чырвоная ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.white": "Белая ніжняя правая палова",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жоўтая ніжняя правая палова",
  "block.minecraft.banner.flow.black": "Чорная плынь",
  "block.minecraft.banner.flow.blue": "Сіняя плынь",
  "block.minecraft.banner.flow.brown": "Карычневая плынь",
  "block.minecraft.banner.flow.cyan": "Бірузовая плынь",
  "block.minecraft.banner.flow.gray": "Шэрая плынь",
  "block.minecraft.banner.flow.green": "Зялёная плынь",
  "block.minecraft.banner.flow.light_blue": "Блакітная плынь",
  "block.minecraft.banner.flow.light_gray": "Светла-шэрая плынь",
  "block.minecraft.banner.flow.lime": "Лаймавая плынь",
  "block.minecraft.banner.flow.magenta": "Пурпурная плынь",
  "block.minecraft.banner.flow.orange": "Аранжавая плынь",
  "block.minecraft.banner.flow.pink": "Ружовая плынь",
  "block.minecraft.banner.flow.purple": "Фіялетавая плынь",
  "block.minecraft.banner.flow.red": "Чырвоная плынь",
  "block.minecraft.banner.flow.white": "Белая плынь",
  "block.minecraft.banner.flow.yellow": "Жоўтая плынь",
  "block.minecraft.banner.flower.black": "Чорная фігура кветкі",
  "block.minecraft.banner.flower.blue": "Сіняя фігура кветкі",
  "block.minecraft.banner.flower.brown": "Карычневая фігура кветкі",
  "block.minecraft.banner.flower.cyan": "Бірузовая фігура кветкі",
  "block.minecraft.banner.flower.gray": "Шэрая фігура кветкі",
  "block.minecraft.banner.flower.green": "Зялёная фігура кветкі",
  "block.minecraft.banner.flower.light_blue": "Блакітная фігура кветкі",
  "block.minecraft.banner.flower.light_gray": "Светла-шэрая фігура кветкі",
  "block.minecraft.banner.flower.lime": "Лаймавая фігура кветкі",
  "block.minecraft.banner.flower.magenta": "Пурпурная фігура кветкі",
  "block.minecraft.banner.flower.orange": "Аранжавая фігура кветкі",
  "block.minecraft.banner.flower.pink": "Ружовая фігура кветкі",
  "block.minecraft.banner.flower.purple": "Фіялетавая фігура кветкі",
  "block.minecraft.banner.flower.red": "Чырвоная фігура кветкі",
  "block.minecraft.banner.flower.white": "Белая фігура кветкі",
  "block.minecraft.banner.flower.yellow": "Жоўтая фігура кветкі",
  "block.minecraft.banner.globe.black": "Чорны глобус",
  "block.minecraft.banner.globe.blue": "Сіні глобус",
  "block.minecraft.banner.globe.brown": "Карычневы глобус",
  "block.minecraft.banner.globe.cyan": "Бірузовы глобус",
  "block.minecraft.banner.globe.gray": "Шэры глобус",
  "block.minecraft.banner.globe.green": "Зялёны глобус",
  "block.minecraft.banner.globe.light_blue": "Блакітны глобус",
  "block.minecraft.banner.globe.light_gray": "Светла-шэры глобус",
  "block.minecraft.banner.globe.lime": "Лаймавы глобус",
  "block.minecraft.banner.globe.magenta": "Пурпурны глобус",
  "block.minecraft.banner.globe.orange": "Аранжавы глобус",
  "block.minecraft.banner.globe.pink": "Ружовы глобус",
  "block.minecraft.banner.globe.purple": "Фіялетавы глобус",
  "block.minecraft.banner.globe.red": "Чырвоны глобус",
  "block.minecraft.banner.globe.white": "Белы глобус",
  "block.minecraft.banner.globe.yellow": "Жоўты глобус",
  "block.minecraft.banner.gradient.black": "Чорны градыент зверху",
  "block.minecraft.banner.gradient.blue": "Сіні градыент зверху",
  "block.minecraft.banner.gradient.brown": "Карычневы градыент зверху",
  "block.minecraft.banner.gradient.cyan": "Бірузовы градыент зверху",
  "block.minecraft.banner.gradient.gray": "Шэры градыент зверху",
  "block.minecraft.banner.gradient.green": "Зялёны градыент зверху",
  "block.minecraft.banner.gradient.light_blue": "Блакітны градыент зверху",
  "block.minecraft.banner.gradient.light_gray": "Светла-шэры градыент зверху",
  "block.minecraft.banner.gradient.lime": "Лаймавы градыент зверху",
  "block.minecraft.banner.gradient.magenta": "Пурпурны градыент зверху",
  "block.minecraft.banner.gradient.orange": "Аранжавы градыент зверху",
  "block.minecraft.banner.gradient.pink": "Ружовы градыент зверху",
  "block.minecraft.banner.gradient.purple": "Фіялетавы градыент зверху",
  "block.minecraft.banner.gradient.red": "Чырвоны градыент зверху",
  "block.minecraft.banner.gradient.white": "Белы градыент зверху",
  "block.minecraft.banner.gradient.yellow": "Жоўты градыент зверху",
  "block.minecraft.banner.gradient_up.black": "Чорны градыент знізу",
  "block.minecraft.banner.gradient_up.blue": "Сіні градыент знізу",
  "block.minecraft.banner.gradient_up.brown": "Карычневы градыент знізу",
  "block.minecraft.banner.gradient_up.cyan": "Бірузовы градыент знізу",
  "block.minecraft.banner.gradient_up.gray": "Шэры градыент знізу",
  "block.minecraft.banner.gradient_up.green": "Зялёны градыент знізу",
  "block.minecraft.banner.gradient_up.light_blue": "Блакітны градыент знізу",
  "block.minecraft.banner.gradient_up.light_gray": "Светла-шэры градыент знізу",
  "block.minecraft.banner.gradient_up.lime": "Лаймавы градыент знізу",
  "block.minecraft.banner.gradient_up.magenta": "Пурпурны градыент знізу",
  "block.minecraft.banner.gradient_up.orange": "Аранжавы градыент знізу",
  "block.minecraft.banner.gradient_up.pink": "Ружовы градыент знізу",
  "block.minecraft.banner.gradient_up.purple": "Фіялетавы градыент знізу",
  "block.minecraft.banner.gradient_up.red": "Чырвоны градыент знізу",
  "block.minecraft.banner.gradient_up.white": "Белы градыент знізу",
  "block.minecraft.banner.gradient_up.yellow": "Жоўты градыент знізу",
  "block.minecraft.banner.guster.black": "Чорны парыў",
  "block.minecraft.banner.guster.blue": "Сіні парыў",
  "block.minecraft.banner.guster.brown": "Карычневы парыў",
  "block.minecraft.banner.guster.cyan": "Бірузовы парыў",
  "block.minecraft.banner.guster.gray": "Шэры парыў",
  "block.minecraft.banner.guster.green": "Зялёны парыў",
  "block.minecraft.banner.guster.light_blue": "Блакітны парыў",
  "block.minecraft.banner.guster.light_gray": "Светла-шэры парыў",
  "block.minecraft.banner.guster.lime": "Лаймавы парыў",
  "block.minecraft.banner.guster.magenta": "Пурпурны парыў",
  "block.minecraft.banner.guster.orange": "Аранжавы парыў",
  "block.minecraft.banner.guster.pink": "Ружовы парыў",
  "block.minecraft.banner.guster.purple": "Фіялетавы парыў",
  "block.minecraft.banner.guster.red": "Чырвоны парыў",
  "block.minecraft.banner.guster.white": "Белы парыў",
  "block.minecraft.banner.guster.yellow": "Жоўты парыў",
  "block.minecraft.banner.half_horizontal.black": "Чорная верхняя палова",
  "block.minecraft.banner.half_horizontal.blue": "Сіняя верхняя палова",
  "block.minecraft.banner.half_horizontal.brown": "Карычневая верхняя палова",
  "block.minecraft.banner.half_horizontal.cyan": "Бірузовая верхняя палова",
  "block.minecraft.banner.half_horizontal.gray": "Шэрая верхняя палова",
  "block.minecraft.banner.half_horizontal.green": "Зялёная верхняя палова",
  "block.minecraft.banner.half_horizontal.light_blue": "Блакітная верхняя палова",
  "block.minecraft.banner.half_horizontal.light_gray": "Светла-шэрая верхняя палова",
  "block.minecraft.banner.half_horizontal.lime": "Лаймавая верхняя палова",
  "block.minecraft.banner.half_horizontal.magenta": "Пурпурная верхняя палова",
  "block.minecraft.banner.half_horizontal.orange": "Аранжавая верхняя палова",
  "block.minecraft.banner.half_horizontal.pink": "Ружовая верхняя палова",
  "block.minecraft.banner.half_horizontal.purple": "Фіялетавая верхняя палова",
  "block.minecraft.banner.half_horizontal.red": "Чырвоная верхняя палова",
  "block.minecraft.banner.half_horizontal.white": "Белая верхняя палова",
  "block.minecraft.banner.half_horizontal.yellow": "Жоўтая верхняя палова",
  "block.minecraft.banner.half_horizontal_bottom.black": "Чорная ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Сіняя ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Карычневая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Бірузовая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Шэрая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зялёная ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Блакітная ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Светла-шэрая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Лаймавая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Пурпурная ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Аранжавая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ружовая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Фіялетавая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.red": "Чырвоная ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.white": "Белая ніжняя палова",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жоўтая ніжняя палова",
  "block.minecraft.banner.half_vertical.black": "Чорная левая палова",
  "block.minecraft.banner.half_vertical.blue": "Сіняя левая палова",
  "block.minecraft.banner.half_vertical.brown": "Карычневая левая палова",
  "block.minecraft.banner.half_vertical.cyan": "Бірузовая левая палова",
  "block.minecraft.banner.half_vertical.gray": "Шэрая левая палова",
  "block.minecraft.banner.half_vertical.green": "Зялёная левая палова",
  "block.minecraft.banner.half_vertical.light_blue": "Блакітная левая палова",
  "block.minecraft.banner.half_vertical.light_gray": "Светла-шэрая левая палова",
  "block.minecraft.banner.half_vertical.lime": "Лаймавая левая палова",
  "block.minecraft.banner.half_vertical.magenta": "Пурпурная левая палова",
  "block.minecraft.banner.half_vertical.orange": "Аранжавая левая палова",
  "block.minecraft.banner.half_vertical.pink": "Ружовая левая палова",
  "block.minecraft.banner.half_vertical.purple": "Фіялетавая левая палова",
  "block.minecraft.banner.half_vertical.red": "Чырвоная левая палова",
  "block.minecraft.banner.half_vertical.white": "Белая левая палова",
  "block.minecraft.banner.half_vertical.yellow": "Жоўтая левая палова",
  "block.minecraft.banner.half_vertical_right.black": "Чорная правая палова",
  "block.minecraft.banner.half_vertical_right.blue": "Сіняя правая палова",
  "block.minecraft.banner.half_vertical_right.brown": "Карычневая правая палова",
  "block.minecraft.banner.half_vertical_right.cyan": "Бірузовая правая палова",
  "block.minecraft.banner.half_vertical_right.gray": "Шэрая правая палова",
  "block.minecraft.banner.half_vertical_right.green": "Зялёная правая палова",
  "block.minecraft.banner.half_vertical_right.light_blue": "Блакітная правая палова",
  "block.minecraft.banner.half_vertical_right.light_gray": "Светла-шэрая правая палова",
  "block.minecraft.banner.half_vertical_right.lime": "Лаймавая правая палова",
  "block.minecraft.banner.half_vertical_right.magenta": "Пурпурная правая палова",
  "block.minecraft.banner.half_vertical_right.orange": "Аранжавая правая палова",
  "block.minecraft.banner.half_vertical_right.pink": "Ружовая правая палова",
  "block.minecraft.banner.half_vertical_right.purple": "Фіялетавая правая палова",
  "block.minecraft.banner.half_vertical_right.red": "Чырвоная правая палова",
  "block.minecraft.banner.half_vertical_right.white": "Белая правая палова",
  "block.minecraft.banner.half_vertical_right.yellow": "Жоўтая правая палова",
  "block.minecraft.banner.mojang.black": "Чорнае штосьці",
  "block.minecraft.banner.mojang.blue": "Сіняе штосьці",
  "block.minecraft.banner.mojang.brown": "Карычневае штосьці",
  "block.minecraft.banner.mojang.cyan": "Бірузовае штосьці",
  "block.minecraft.banner.mojang.gray": "Шэрае штосьці",
  "block.minecraft.banner.mojang.green": "Зялёнае штосьці",
  "block.minecraft.banner.mojang.light_blue": "Блакітнае штосьці",
  "block.minecraft.banner.mojang.light_gray": "Светла-шэрае штосьці",
  "block.minecraft.banner.mojang.lime": "Лаймавае штосьці",
  "block.minecraft.banner.mojang.magenta": "Пурпурнае штосьці",
  "block.minecraft.banner.mojang.orange": "Аранжавае штосьці",
  "block.minecraft.banner.mojang.pink": "Ружовае штосьці",
  "block.minecraft.banner.mojang.purple": "Фіялетавае штосьці",
  "block.minecraft.banner.mojang.red": "Чырвонае штосьці",
  "block.minecraft.banner.mojang.white": "Белае штосьці",
  "block.minecraft.banner.mojang.yellow": "Жоўтае штосьці",
  "block.minecraft.banner.piglin.black": "Чорны лыч",
  "block.minecraft.banner.piglin.blue": "Сіні лыч",
  "block.minecraft.banner.piglin.brown": "Карычневы лыч",
  "block.minecraft.banner.piglin.cyan": "Бірузовы лыч",
  "block.minecraft.banner.piglin.gray": "Шэры лыч",
  "block.minecraft.banner.piglin.green": "Зялёны лыч",
  "block.minecraft.banner.piglin.light_blue": "Блакітны лыч",
  "block.minecraft.banner.piglin.light_gray": "Светла-шэры лыч",
  "block.minecraft.banner.piglin.lime": "Лаймавы лыч",
  "block.minecraft.banner.piglin.magenta": "Пурпурны лыч",
  "block.minecraft.banner.piglin.orange": "Аранжавы лыч",
  "block.minecraft.banner.piglin.pink": "Ружовы лыч",
  "block.minecraft.banner.piglin.purple": "Фіялетавы лыч",
  "block.minecraft.banner.piglin.red": "Чырвоны лыч",
  "block.minecraft.banner.piglin.white": "Белы лыч",
  "block.minecraft.banner.piglin.yellow": "Жоўты лыч",
  "block.minecraft.banner.rhombus.black": "Чорны ромб",
  "block.minecraft.banner.rhombus.blue": "Сіні ромб",
  "block.minecraft.banner.rhombus.brown": "Карычневы ромб",
  "block.minecraft.banner.rhombus.cyan": "Бірузовы ромб",
  "block.minecraft.banner.rhombus.gray": "Шэры ромб",
  "block.minecraft.banner.rhombus.green": "Зялёны ромб",
  "block.minecraft.banner.rhombus.light_blue": "Блакітны ромб",
  "block.minecraft.banner.rhombus.light_gray": "Светла-шэры ромб",
  "block.minecraft.banner.rhombus.lime": "Лаймавы ромб",
  "block.minecraft.banner.rhombus.magenta": "Пурпурны ромб",
  "block.minecraft.banner.rhombus.orange": "Аранжавы ромб",
  "block.minecraft.banner.rhombus.pink": "Ружовы ромб",
  "block.minecraft.banner.rhombus.purple": "Фіялетавы ромб",
  "block.minecraft.banner.rhombus.red": "Чырвоны ромб",
  "block.minecraft.banner.rhombus.white": "Белы ромб",
  "block.minecraft.banner.rhombus.yellow": "Жоўты ромб",
  "block.minecraft.banner.skull.black": "Чорная фігура чэрапа",
  "block.minecraft.banner.skull.blue": "Сіняя фігура чэрапа",
  "block.minecraft.banner.skull.brown": "Карычневая фігура чэрапа",
  "block.minecraft.banner.skull.cyan": "Бірузовая фігура чэрапа",
  "block.minecraft.banner.skull.gray": "Шэрая фігура чэрапа",
  "block.minecraft.banner.skull.green": "Зялёная фігура чэрапа",
  "block.minecraft.banner.skull.light_blue": "Блакітная фігура чэрапа",
  "block.minecraft.banner.skull.light_gray": "Светла-шэрая фігура чэрапа",
  "block.minecraft.banner.skull.lime": "Лаймавая фігура чэрапа",
  "block.minecraft.banner.skull.magenta": "Пурпурная фігура чэрапа",
  "block.minecraft.banner.skull.orange": "Аранжавая фігура чэрапа",
  "block.minecraft.banner.skull.pink": "Ружовая фігура чэрапа",
  "block.minecraft.banner.skull.purple": "Фіялетавая фігура чэрапа",
  "block.minecraft.banner.skull.red": "Чырвоная фігура чэрапа",
  "block.minecraft.banner.skull.white": "Белая фігура чэрапа",
  "block.minecraft.banner.skull.yellow": "Жоўтая фігура чэрапа",
  "block.minecraft.banner.small_stripes.black": "Чорныя слупкі",
  "block.minecraft.banner.small_stripes.blue": "Сінія слупкі",
  "block.minecraft.banner.small_stripes.brown": "Карычневыя слупкі",
  "block.minecraft.banner.small_stripes.cyan": "Бірузовыя слупкі",
  "block.minecraft.banner.small_stripes.gray": "Шэрыя слупкі",
  "block.minecraft.banner.small_stripes.green": "Зялёныя слупкі",
  "block.minecraft.banner.small_stripes.light_blue": "Блакітныя слупкі",
  "block.minecraft.banner.small_stripes.light_gray": "Светла-шэрыя слупкі",
  "block.minecraft.banner.small_stripes.lime": "Лаймавыя слупкі",
  "block.minecraft.banner.small_stripes.magenta": "Пурпурныя слупкі",
  "block.minecraft.banner.small_stripes.orange": "Аранжавыя слупкі",
  "block.minecraft.banner.small_stripes.pink": "Ружовыя слупкі",
  "block.minecraft.banner.small_stripes.purple": "Фіялетавыя слупкі",
  "block.minecraft.banner.small_stripes.red": "Чырвоныя слупкі",
  "block.minecraft.banner.small_stripes.white": "Белыя слупкі",
  "block.minecraft.banner.small_stripes.yellow": "Жоўтыя слупкі",
  "block.minecraft.banner.square_bottom_left.black": "Чорны ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.blue": "Сіні ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.brown": "Карычневы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.cyan": "Бірузовы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.gray": "Шэры ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.green": "Зялёны ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.light_blue": "Блакітны ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.light_gray": "Светла-шэры ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.lime": "Лаймавы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.magenta": "Пурпурны ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.orange": "Аранжавы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.pink": "Ружовы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.purple": "Фіялетавы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.red": "Чырвоны ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.white": "Белы ніжні кут злева",
  "block.minecraft.banner.square_bottom_left.yellow": "Жоўты ніжні кут злева",
  "block.minecraft.banner.square_bottom_right.black": "Чорны ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.blue": "Сіні ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.brown": "Карычневы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.cyan": "Бірузовы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.gray": "Шэры ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.green": "Зялёны ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.light_blue": "Блакітны ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.light_gray": "Светла-шэры ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.lime": "Лаймавы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпурны ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.orange": "Аранжавы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.pink": "Ружовы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.purple": "Фіялетавы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.red": "Чырвоны ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.white": "Белы ніжні кут справа",
  "block.minecraft.banner.square_bottom_right.yellow": "Жоўты ніжні кут справа",
  "block.minecraft.banner.square_top_left.black": "Чорны верхні кут злева",
  "block.minecraft.banner.square_top_left.blue": "Сіні верхні кут злева",
  "block.minecraft.banner.square_top_left.brown": "Карычневы верхні кут злева",
  "block.minecraft.banner.square_top_left.cyan": "Бірузовы верхні кут злева",
  "block.minecraft.banner.square_top_left.gray": "Шэры верхні кут злева",
  "block.minecraft.banner.square_top_left.green": "Зялёны верхні кут злева",
  "block.minecraft.banner.square_top_left.light_blue": "Блакітны верхні кут злева",
  "block.minecraft.banner.square_top_left.light_gray": "Светла-шэры верхні кут злева",
  "block.minecraft.banner.square_top_left.lime": "Лаймавы верхні кут злева",
  "block.minecraft.banner.square_top_left.magenta": "Пурпурны верхні кут злева",
  "block.minecraft.banner.square_top_left.orange": "Аранжавы верхні кут злева",
  "block.minecraft.banner.square_top_left.pink": "Ружовы верхні кут злева",
  "block.minecraft.banner.square_top_left.purple": "Фіялетавы верхні кут злева",
  "block.minecraft.banner.square_top_left.red": "Чырвоны верхні кут злева",
  "block.minecraft.banner.square_top_left.white": "Белы верхні кут злева",
  "block.minecraft.banner.square_top_left.yellow": "Жоўты верхні кут злева",
  "block.minecraft.banner.square_top_right.black": "Чорны верхні кут справа",
  "block.minecraft.banner.square_top_right.blue": "Сіні верхні кут справа",
  "block.minecraft.banner.square_top_right.brown": "Карычневы верхні кут справа",
  "block.minecraft.banner.square_top_right.cyan": "Бірузовы верхні кут справа",
  "block.minecraft.banner.square_top_right.gray": "Шэры верхні кут справа",
  "block.minecraft.banner.square_top_right.green": "Зялёны верхні кут справа",
  "block.minecraft.banner.square_top_right.light_blue": "Блакітны верхні кут справа",
  "block.minecraft.banner.square_top_right.light_gray": "Светла-шэры верхні кут справа",
  "block.minecraft.banner.square_top_right.lime": "Лаймавы верхні кут справа",
  "block.minecraft.banner.square_top_right.magenta": "Пурпурны верхні кут справа",
  "block.minecraft.banner.square_top_right.orange": "Аранжавы верхні кут справа",
  "block.minecraft.banner.square_top_right.pink": "Ружовы верхні кут справа",
  "block.minecraft.banner.square_top_right.purple": "Фіялетавы верхні кут справа",
  "block.minecraft.banner.square_top_right.red": "Чырвоны верхні кут справа",
  "block.minecraft.banner.square_top_right.white": "Белы верхні кут справа",
  "block.minecraft.banner.square_top_right.yellow": "Жоўты верхні кут справа",
  "block.minecraft.banner.straight_cross.black": "Чорны крыж",
  "block.minecraft.banner.straight_cross.blue": "Сіні крыж",
  "block.minecraft.banner.straight_cross.brown": "Карычневы крыж",
  "block.minecraft.banner.straight_cross.cyan": "Бірузовы крыж",
  "block.minecraft.banner.straight_cross.gray": "Шэры крыж",
  "block.minecraft.banner.straight_cross.green": "Зялёны крыж",
  "block.minecraft.banner.straight_cross.light_blue": "Блакітны крыж",
  "block.minecraft.banner.straight_cross.light_gray": "Светла-шэры крыж",
  "block.minecraft.banner.straight_cross.lime": "Лаймавы крыж",
  "block.minecraft.banner.straight_cross.magenta": "Пурпурны крыж",
  "block.minecraft.banner.straight_cross.orange": "Аранжавы крыж",
  "block.minecraft.banner.straight_cross.pink": "Ружовы крыж",
  "block.minecraft.banner.straight_cross.purple": "Фіялетавы крыж",
  "block.minecraft.banner.straight_cross.red": "Чырвоны крыж",
  "block.minecraft.banner.straight_cross.white": "Белы крыж",
  "block.minecraft.banner.straight_cross.yellow": "Жоўты крыж",
  "block.minecraft.banner.stripe_bottom.black": "Чорны падножак",
  "block.minecraft.banner.stripe_bottom.blue": "Сіні падножак",
  "block.minecraft.banner.stripe_bottom.brown": "Карычневы падножак",
  "block.minecraft.banner.stripe_bottom.cyan": "Бірузовы падножак",
  "block.minecraft.banner.stripe_bottom.gray": "Шэры падножак",
  "block.minecraft.banner.stripe_bottom.green": "Зялёны падножак",
  "block.minecraft.banner.stripe_bottom.light_blue": "Блакітны падножак",
  "block.minecraft.banner.stripe_bottom.light_gray": "Светла-шэры падножак",
  "block.minecraft.banner.stripe_bottom.lime": "Лаймавы падножак",
  "block.minecraft.banner.stripe_bottom.magenta": "Пурпурны падножак",
  "block.minecraft.banner.stripe_bottom.orange": "Аранжавы падножак",
  "block.minecraft.banner.stripe_bottom.pink": "Ружовы падножак",
  "block.minecraft.banner.stripe_bottom.purple": "Фіялетавы падножак",
  "block.minecraft.banner.stripe_bottom.red": "Чырвоны падножак",
  "block.minecraft.banner.stripe_bottom.white": "Белы падножак",
  "block.minecraft.banner.stripe_bottom.yellow": "Жоўты падножак",
  "block.minecraft.banner.stripe_center.black": "Чорны слуп",
  "block.minecraft.banner.stripe_center.blue": "Сіні слуп",
  "block.minecraft.banner.stripe_center.brown": "Карычневы слуп",
  "block.minecraft.banner.stripe_center.cyan": "Бірузовы слуп",
  "block.minecraft.banner.stripe_center.gray": "Шэры слуп",
  "block.minecraft.banner.stripe_center.green": "Зялёны слуп",
  "block.minecraft.banner.stripe_center.light_blue": "Блакітны слуп",
  "block.minecraft.banner.stripe_center.light_gray": "Светла-шэры слуп",
  "block.minecraft.banner.stripe_center.lime": "Лаймавы слуп",
  "block.minecraft.banner.stripe_center.magenta": "Пурпурны слуп",
  "block.minecraft.banner.stripe_center.orange": "Аранжавы слуп",
  "block.minecraft.banner.stripe_center.pink": "Ружовы слуп",
  "block.minecraft.banner.stripe_center.purple": "Фіялетавы слуп",
  "block.minecraft.banner.stripe_center.red": "Чырвоны слуп",
  "block.minecraft.banner.stripe_center.white": "Белы слуп",
  "block.minecraft.banner.stripe_center.yellow": "Жоўты слуп",
  "block.minecraft.banner.stripe_downleft.black": "Чорная левая перавязь",
  "block.minecraft.banner.stripe_downleft.blue": "Сіняя левая перавязь",
  "block.minecraft.banner.stripe_downleft.brown": "Карычневая левая перавязь",
  "block.minecraft.banner.stripe_downleft.cyan": "Бірузовая левая перавязь",
  "block.minecraft.banner.stripe_downleft.gray": "Шэрая левая перавязь",
  "block.minecraft.banner.stripe_downleft.green": "Зялёная левая перавязь",
  "block.minecraft.banner.stripe_downleft.light_blue": "Блакітная левая перавязь",
  "block.minecraft.banner.stripe_downleft.light_gray": "Светла-шэрая левая перавязь",
  "block.minecraft.banner.stripe_downleft.lime": "Лаймавая левая перавязь",
  "block.minecraft.banner.stripe_downleft.magenta": "Пурпурная левая перавязь",
  "block.minecraft.banner.stripe_downleft.orange": "Аранжавая левая перавязь",
  "block.minecraft.banner.stripe_downleft.pink": "Ружовая левая перавязь",
  "block.minecraft.banner.stripe_downleft.purple": "Фіялетавая левая перавязь",
  "block.minecraft.banner.stripe_downleft.red": "Чырвоная левая перавязь",
  "block.minecraft.banner.stripe_downleft.white": "Белая левая перавязь",
  "block.minecraft.banner.stripe_downleft.yellow": "Жоўтая левая перавязь",
  "block.minecraft.banner.stripe_downright.black": "Чорная перавязь",
  "block.minecraft.banner.stripe_downright.blue": "Сіняя перавязь",
  "block.minecraft.banner.stripe_downright.brown": "Карычневая перавязь",
  "block.minecraft.banner.stripe_downright.cyan": "Бірузовая перавязь",
  "block.minecraft.banner.stripe_downright.gray": "Шэрая перавязь",
  "block.minecraft.banner.stripe_downright.green": "Зялёная перавязь",
  "block.minecraft.banner.stripe_downright.light_blue": "Блакітная перавязь",
  "block.minecraft.banner.stripe_downright.light_gray": "Светла-шэрая перавязь",
  "block.minecraft.banner.stripe_downright.lime": "Лаймавая перавязь",
  "block.minecraft.banner.stripe_downright.magenta": "Пурпурная перавязь",
  "block.minecraft.banner.stripe_downright.orange": "Аранжавая перавязь",
  "block.minecraft.banner.stripe_downright.pink": "Ружовая перавязь",
  "block.minecraft.banner.stripe_downright.purple": "Фіялетавая перавязь",
  "block.minecraft.banner.stripe_downright.red": "Чырвоная перавязь",
  "block.minecraft.banner.stripe_downright.white": "Белая перавязь",
  "block.minecraft.banner.stripe_downright.yellow": "Жоўтая перавязь",
  "block.minecraft.banner.stripe_left.black": "Чорная левая трэць",
  "block.minecraft.banner.stripe_left.blue": "Сіняя левая трэць",
  "block.minecraft.banner.stripe_left.brown": "Карычневая левая трэць",
  "block.minecraft.banner.stripe_left.cyan": "Бірузовая левая трэць",
  "block.minecraft.banner.stripe_left.gray": "Шэрая левая трэць",
  "block.minecraft.banner.stripe_left.green": "Зялёная левая трэць",
  "block.minecraft.banner.stripe_left.light_blue": "Блакітная левая трэць",
  "block.minecraft.banner.stripe_left.light_gray": "Светла-шэрая левая трэць",
  "block.minecraft.banner.stripe_left.lime": "Лаймавая левая трэць",
  "block.minecraft.banner.stripe_left.magenta": "Пурпурная левая трэць",
  "block.minecraft.banner.stripe_left.orange": "Аранжавая левая трэць",
  "block.minecraft.banner.stripe_left.pink": "Ружовая левая трэць",
  "block.minecraft.banner.stripe_left.purple": "Фіялетавая левая трэць",
  "block.minecraft.banner.stripe_left.red": "Чырвоная левая трэць",
  "block.minecraft.banner.stripe_left.white": "Белая левая трэць",
  "block.minecraft.banner.stripe_left.yellow": "Жоўтая левая трэць",
  "block.minecraft.banner.stripe_middle.black": "Чорны пас",
  "block.minecraft.banner.stripe_middle.blue": "Сіні пас",
  "block.minecraft.banner.stripe_middle.brown": "Карычневы пас",
  "block.minecraft.banner.stripe_middle.cyan": "Бірузовы пас",
  "block.minecraft.banner.stripe_middle.gray": "Шэры пас",
  "block.minecraft.banner.stripe_middle.green": "Зялёны пас",
  "block.minecraft.banner.stripe_middle.light_blue": "Блакітны пас",
  "block.minecraft.banner.stripe_middle.light_gray": "Светла-шэры пас",
  "block.minecraft.banner.stripe_middle.lime": "Лаймавы пас",
  "block.minecraft.banner.stripe_middle.magenta": "Пурпурны пас",
  "block.minecraft.banner.stripe_middle.orange": "Аранжавы пас",
  "block.minecraft.banner.stripe_middle.pink": "Ружовы пас",
  "block.minecraft.banner.stripe_middle.purple": "Фіялетавы пас",
  "block.minecraft.banner.stripe_middle.red": "Чырвоны пас",
  "block.minecraft.banner.stripe_middle.white": "Белы пас",
  "block.minecraft.banner.stripe_middle.yellow": "Жоўты пас",
  "block.minecraft.banner.stripe_right.black": "Чорная правая трэць",
  "block.minecraft.banner.stripe_right.blue": "Сіняя правая трэць",
  "block.minecraft.banner.stripe_right.brown": "Карычневая правая трэць",
  "block.minecraft.banner.stripe_right.cyan": "Бірузовая правая трэць",
  "block.minecraft.banner.stripe_right.gray": "Шэрая правая трэць",
  "block.minecraft.banner.stripe_right.green": "Зялёная правая трэць",
  "block.minecraft.banner.stripe_right.light_blue": "Блакітная правая трэць",
  "block.minecraft.banner.stripe_right.light_gray": "Светла-шэрая правая трэць",
  "block.minecraft.banner.stripe_right.lime": "Лаймавая правая трэць",
  "block.minecraft.banner.stripe_right.magenta": "Пурпурная правая трэць",
  "block.minecraft.banner.stripe_right.orange": "Аранжавая правая трэць",
  "block.minecraft.banner.stripe_right.pink": "Ружовая правая трэць",
  "block.minecraft.banner.stripe_right.purple": "Фіялетавая правая трэць",
  "block.minecraft.banner.stripe_right.red": "Чырвоная правая трэць",
  "block.minecraft.banner.stripe_right.white": "Белая правая трэць",
  "block.minecraft.banner.stripe_right.yellow": "Жоўтая правая трэць",
  "block.minecraft.banner.stripe_top.black": "Чорная вяршыня",
  "block.minecraft.banner.stripe_top.blue": "Сіняя вяршыня",
  "block.minecraft.banner.stripe_top.brown": "Карычневая вяршыня",
  "block.minecraft.banner.stripe_top.cyan": "Бірузовая вяршыня",
  "block.minecraft.banner.stripe_top.gray": "Шэрая вяршыня",
  "block.minecraft.banner.stripe_top.green": "Зялёная вяршыня",
  "block.minecraft.banner.stripe_top.light_blue": "Блакітная вяршыня",
  "block.minecraft.banner.stripe_top.light_gray": "Светла-шэрая вяршыня",
  "block.minecraft.banner.stripe_top.lime": "Лаймавая вяршыня",
  "block.minecraft.banner.stripe_top.magenta": "Пурпурная вяршыня",
  "block.minecraft.banner.stripe_top.orange": "Аранжавая вяршыня",
  "block.minecraft.banner.stripe_top.pink": "Ружовая вяршыня",
  "block.minecraft.banner.stripe_top.purple": "Фіялетавая вяршыня",
  "block.minecraft.banner.stripe_top.red": "Чырвоная вяршыня",
  "block.minecraft.banner.stripe_top.white": "Белая вяршыня",
  "block.minecraft.banner.stripe_top.yellow": "Жоўтая вяршыня",
  "block.minecraft.banner.triangle_bottom.black": "Чорнае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.blue": "Сіняе скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.brown": "Карычневае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.cyan": "Бірузовае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.gray": "Шэрае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.green": "Зялёнае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.light_blue": "Блакітнае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.light_gray": "Светла-шэрае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.lime": "Лаймавае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.magenta": "Пурпурнае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.orange": "Аранжавае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.pink": "Ружовае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.purple": "Фіялетавае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.red": "Чырвонае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.white": "Белае скарочанае вастрыё",
  "block.minecraft.banner.triangle_bottom.yellow": "Жоўтае скарочанае вастрыё",
  "block.minecraft.banner.triangle_top.black": "Чорнае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.blue": "Сіняе скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.brown": "Карычневае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.cyan": "Бірузовае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.gray": "Шэрае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.green": "Зялёнае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.light_blue": "Блакітнае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.light_gray": "Светла-шэрае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.lime": "Лаймавае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.magenta": "Пурпурнае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.orange": "Аранжавае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.pink": "Ружовае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.purple": "Фіялетавае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.red": "Чырвонае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.white": "Белае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangle_top.yellow": "Жоўтае скарочанае перакуленае вастрыё",
  "block.minecraft.banner.triangles_bottom.black": "Чорны зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.blue": "Сіні зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.brown": "Карычневы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.cyan": "Бірузовы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.gray": "Шэры зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.green": "Зялёны зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.light_blue": "Блакітны зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.light_gray": "Светла-шэры зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.lime": "Лаймавы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.magenta": "Пурпурны зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.orange": "Аранжавы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.pink": "Ружовы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.purple": "Фіялетавы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.red": "Чырвоны зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.white": "Белы зубчасты падножак",
  "block.minecraft.banner.triangles_bottom.yellow": "Жоўты зубчасты падножак",
  "block.minecraft.banner.triangles_top.black": "Чорная зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.blue": "Сіняя зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.brown": "Карычневая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.cyan": "Бірузовая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.gray": "Шэрая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.green": "Зялёная зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.light_blue": "Блакітная зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.light_gray": "Светла-шэрая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.lime": "Лаймавая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.magenta": "Пурпурная зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.orange": "Аранжавая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.pink": "Ружовая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.purple": "Фіялетавая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.red": "Чырвоная зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.white": "Белая зубчастая вяршыня",
  "block.minecraft.banner.triangles_top.yellow": "Жоўтая зубчастая вяршыня",
  "block.minecraft.barrel": "Бочка",
  "block.minecraft.barrier": "Бар’ер",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Асноўны эфект",
  "block.minecraft.beacon.secondary": "Дадатковы эфект",
  "block.minecraft.bed.no_sleep": "Вы можаце спаць толькі ўначы або падчас навальніцы",
  "block.minecraft.bed.not_safe": "Зараз нельга спаць, дзесьці побач пачвары!",
  "block.minecraft.bed.obstructed": "На гэты ложак нельга легчы",
  "block.minecraft.bed.occupied": "Гэты ложак заняты",
  "block.minecraft.bed.too_far_away": "Вы не можаце легчы, ложак занадта далёка",
  "block.minecraft.bedrock": "Карэнная парода",
  "block.minecraft.bee_nest": "Пчалінае гняздо",
  "block.minecraft.beehive": "Вулей",
  "block.minecraft.beetroots": "Бурак",
  "block.minecraft.bell": "Звон",
  "block.minecraft.big_dripleaf": "Вялікі кропляліст",
  "block.minecraft.big_dripleaf_stem": "Сцябло вялікага кроплялісту",
  "block.minecraft.birch_button": "Бярозавая кнопка",
  "block.minecraft.birch_door": "Бярозавыя дзверы",
  "block.minecraft.birch_fence": "Бярозавы плот",
  "block.minecraft.birch_fence_gate": "Бярозавая брамка",
  "block.minecraft.birch_hanging_sign": "Бярозавая падвесная шыльда",
  "block.minecraft.birch_leaves": "Бярозавае лісце",
  "block.minecraft.birch_log": "Бярозавае бервяно",
  "block.minecraft.birch_planks": "Бярозавыя дошкі",
  "block.minecraft.birch_pressure_plate": "Бярозавая націскная пліта",
  "block.minecraft.birch_sapling": "Саджанец бярозы",
  "block.minecraft.birch_shelf": "Бярозавая паліца",
  "block.minecraft.birch_sign": "Бярозавая шыльда",
  "block.minecraft.birch_slab": "Бярозавая пліта",
  "block.minecraft.birch_stairs": "Бярозавыя прыступкі",
  "block.minecraft.birch_trapdoor": "Бярозавы люк",
  "block.minecraft.birch_wall_hanging_sign": "Бярозавая насценная падвесная шыльда",
  "block.minecraft.birch_wall_sign": "Бярозавая насценная шыльда",
  "block.minecraft.birch_wood": "Бярозавая драўніна",
  "block.minecraft.black_banner": "Чорны сцяг",
  "block.minecraft.black_bed": "Чорны ложак",
  "block.minecraft.black_candle": "Чорная свечка",
  "block.minecraft.black_candle_cake": "Торт з чорнай свечкай",
  "block.minecraft.black_carpet": "Чорны дыван",
  "block.minecraft.black_concrete": "Чорны бетон",
  "block.minecraft.black_concrete_powder": "Чорны цэмент",
  "block.minecraft.black_glazed_terracotta": "Чорная паліваная кераміка",
  "block.minecraft.black_shulker_box": "Чорная шалкеравая скрыня",
  "block.minecraft.black_stained_glass": "Чорнае шкло",
  "block.minecraft.black_stained_glass_pane": "Чорная шыба",
  "block.minecraft.black_terracotta": "Чорная кераміка",
  "block.minecraft.black_wool": "Чорная воўна",
  "block.minecraft.blackstone": "Чарніт",
  "block.minecraft.blackstone_slab": "Пліта з чарніту",
  "block.minecraft.blackstone_stairs": "Прыступкі з чарніту",
  "block.minecraft.blackstone_wall": "Сцяна з чарніту",
  "block.minecraft.blast_furnace": "Доменная печ",
  "block.minecraft.blue_banner": "Сіні сцяг",
  "block.minecraft.blue_bed": "Сіні ложак",
  "block.minecraft.blue_candle": "Сіняя свечка",
  "block.minecraft.blue_candle_cake": "Торт з сіняй свечкай",
  "block.minecraft.blue_carpet": "Сіні дыван",
  "block.minecraft.blue_concrete": "Сіні бетон",
  "block.minecraft.blue_concrete_powder": "Сіні цэмент",
  "block.minecraft.blue_glazed_terracotta": "Сіняя паліваная кераміка",
  "block.minecraft.blue_ice": "Сіні лёд",
  "block.minecraft.blue_orchid": "Блакітная архідэя",
  "block.minecraft.blue_shulker_box": "Сіняя шалкеравая скрыня",
  "block.minecraft.blue_stained_glass": "Сіняе шкло",
  "block.minecraft.blue_stained_glass_pane": "Сіняя шыба",
  "block.minecraft.blue_terracotta": "Сіняя кераміка",
  "block.minecraft.blue_wool": "Сіняя воўна",
  "block.minecraft.bone_block": "Касцявы блок",
  "block.minecraft.bookshelf": "Кніжная палічка",
  "block.minecraft.brain_coral": "Мазгавы карал",
  "block.minecraft.brain_coral_block": "Блок мазгавога карала",
  "block.minecraft.brain_coral_fan": "Веерны мазгавы карал",
  "block.minecraft.brain_coral_wall_fan": "Гарызантальны веерны мазгавы карал",
  "block.minecraft.brewing_stand": "Варачная стойка",
  "block.minecraft.brick_slab": "Цагляная пліта",
  "block.minecraft.brick_stairs": "Цагляныя прыступкі",
  "block.minecraft.brick_wall": "Цагляная сцяна",
  "block.minecraft.bricks": "Цэгла",
  "block.minecraft.brown_banner": "Карычневы сцяг",
  "block.minecraft.brown_bed": "Карычневы ложак",
  "block.minecraft.brown_candle": "Карычневая свечка",
  "block.minecraft.brown_candle_cake": "Торт з карычневай свечкай",
  "block.minecraft.brown_carpet": "Карычневы дыван",
  "block.minecraft.brown_concrete": "Карычневы бетон",
  "block.minecraft.brown_concrete_powder": "Карычневы цэмент",
  "block.minecraft.brown_glazed_terracotta": "Карычневая паліваная кераміка",
  "block.minecraft.brown_mushroom": "Баравік",
  "block.minecraft.brown_mushroom_block": "Блок баравіка",
  "block.minecraft.brown_shulker_box": "Карычневая шалкеравая скрыня",
  "block.minecraft.brown_stained_glass": "Карычневае шкло",
  "block.minecraft.brown_stained_glass_pane": "Карычневая шыба",
  "block.minecraft.brown_terracotta": "Карычневая кераміка",
  "block.minecraft.brown_wool": "Карычневая воўна",
  "block.minecraft.bubble_column": "Калона бурбалак",
  "block.minecraft.bubble_coral": "Пузырысты карал",
  "block.minecraft.bubble_coral_block": "Блок пузырыстага карала",
  "block.minecraft.bubble_coral_fan": "Веерны пузырысты карал",
  "block.minecraft.bubble_coral_wall_fan": "Гарызантальны веерны пузырысты карал",
  "block.minecraft.budding_amethyst": "Радовішча аметысту",
  "block.minecraft.bush": "Куст",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кветка кактуса",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцыт",
  "block.minecraft.calibrated_sculk_sensor": "Адкалібраваны скалкавы сэнсар",
  "block.minecraft.campfire": "Вогнішча",
  "block.minecraft.candle": "Свечка",
  "block.minecraft.candle_cake": "Торт са свечкай",
  "block.minecraft.carrots": "Морква",
  "block.minecraft.cartography_table": "Варштат картографа",
  "block.minecraft.carved_pumpkin": "Выразаны гарбуз",
  "block.minecraft.cauldron": "Кацёл",
  "block.minecraft.cave_air": "Пячорнае паветра",
  "block.minecraft.cave_vines": "Пячорная лаза",
  "block.minecraft.cave_vines_plant": "Сцябло пячорнай лазы",
  "block.minecraft.chain": "Ланцуг",
  "block.minecraft.chain_command_block": "Ланцуговы камандны блок",
  "block.minecraft.cherry_button": "Кнопка з вішнёвай драўніны",
  "block.minecraft.cherry_door": "Дзверы з вішнёвай драўніны",
  "block.minecraft.cherry_fence": "Плот з вішнёвай драўніны",
  "block.minecraft.cherry_fence_gate": "Брамка з вішнёвай драўніны",
  "block.minecraft.cherry_hanging_sign": "Падвесная шыльда з вішнёвай драўніны",
  "block.minecraft.cherry_leaves": "Вішнёвае лісце",
  "block.minecraft.cherry_log": "Вішнёвае бервяно",
  "block.minecraft.cherry_planks": "Дошкі з вішнёвай драўніны",
  "block.minecraft.cherry_pressure_plate": "Націскная пліта з вішнёвай драўніны",
  "block.minecraft.cherry_sapling": "Саджанец вішні",
  "block.minecraft.cherry_shelf": "Паліца з вішнёвай драўніны",
  "block.minecraft.cherry_sign": "Шыльда з вішнёвай драўніны",
  "block.minecraft.cherry_slab": "Пліта з вішнёвай драўніны",
  "block.minecraft.cherry_stairs": "Прыступкі з вішнёвай драўніны",
  "block.minecraft.cherry_trapdoor": "Люк з вішнёвай драўніны",
  "block.minecraft.cherry_wall_hanging_sign": "Насценная падвесная шыльда з вішнёвай драўніны",
  "block.minecraft.cherry_wall_sign": "Насценная шыльда з вішнёвай драўніны",
  "block.minecraft.cherry_wood": "Вішнёвая драўніна",
  "block.minecraft.chest": "Куфар",
  "block.minecraft.chipped_anvil": "Пашкоджанае кавадла",
  "block.minecraft.chiseled_bookshelf": "Разьбяная кніжная палічка",
  "block.minecraft.chiseled_copper": "Разьбяная медзь",
  "block.minecraft.chiseled_deepslate": "Разьбяны сланец",
  "block.minecraft.chiseled_nether_bricks": "Разьбяная нэдарская цэгла",
  "block.minecraft.chiseled_polished_blackstone": "Разьбяны паліраваны чарніт",
  "block.minecraft.chiseled_quartz_block": "Разьбяны кварцавы блок",
  "block.minecraft.chiseled_red_sandstone": "Разьбяны чырвоны пясчанік",
  "block.minecraft.chiseled_resin_bricks": "Разьбяная смаляная цэгла",
  "block.minecraft.chiseled_sandstone": "Разьбяны пясчанік",
  "block.minecraft.chiseled_stone_bricks": "Разьбяная каменная цэгла",
  "block.minecraft.chiseled_tuff": "Разьбяны туф",
  "block.minecraft.chiseled_tuff_bricks": "Разьбяная туфавая цэгла",
  "block.minecraft.chorus_flower": "Кветка хоруса",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Гліна",
  "block.minecraft.closed_eyeblossom": "Закрыты вокацвет",
  "block.minecraft.coal_block": "Вугальны блок",
  "block.minecraft.coal_ore": "Вугальная руда",
  "block.minecraft.coarse_dirt": "Грубая зямля",
  "block.minecraft.cobbled_deepslate": "Бутавы сланец",
  "block.minecraft.cobbled_deepslate_slab": "Пліта з бутавага сланцу",
  "block.minecraft.cobbled_deepslate_stairs": "Прыступкі з бутавага сланцу",
  "block.minecraft.cobbled_deepslate_wall": "Сцяна з бутавага сланцу",
  "block.minecraft.cobblestone": "Бут",
  "block.minecraft.cobblestone_slab": "Пліта з буту",
  "block.minecraft.cobblestone_stairs": "Прыступкі з буту",
  "block.minecraft.cobblestone_wall": "Сцяна з буту",
  "block.minecraft.cobweb": "Павуцінне",
  "block.minecraft.cocoa": "Какава",
  "block.minecraft.command_block": "Камандны блок",
  "block.minecraft.comparator": "Кампаратар",
  "block.minecraft.composter": "Кампоставая скрыня",
  "block.minecraft.conduit": "Сфера марскіх чараў",
  "block.minecraft.copper_bars": "Мядзяныя краты",
  "block.minecraft.copper_block": "Мядзяны блок",
  "block.minecraft.copper_bulb": "Мядзяная лямпа",
  "block.minecraft.copper_chain": "Мядзяны ланцуг",
  "block.minecraft.copper_chest": "Мядзяны куфар",
  "block.minecraft.copper_door": "Мядзяныя дзверы",
  "block.minecraft.copper_golem_statue": "Статуя мядзянага голема",
  "block.minecraft.copper_grate": "Мядзяная рашотка",
  "block.minecraft.copper_lantern": "Мядзяны ліхтар",
  "block.minecraft.copper_ore": "Мядзяная руда",
  "block.minecraft.copper_torch": "Мядзяны факел",
  "block.minecraft.copper_trapdoor": "Мядзяны люк",
  "block.minecraft.copper_wall_torch": "Насценны мядзяны факел",
  "block.minecraft.cornflower": "Валошка",
  "block.minecraft.cracked_deepslate_bricks": "Патрэсканая сланцавая цэгла",
  "block.minecraft.cracked_deepslate_tiles": "Патрэсканая сланцавая кафля",
  "block.minecraft.cracked_nether_bricks": "Патрэсканая нэдарская цэгла",
  "block.minecraft.cracked_polished_blackstone_bricks": "Патрэсканая цэгла з паліраванага чарніту",
  "block.minecraft.cracked_stone_bricks": "Патрэсканая каменная цэгла",
  "block.minecraft.crafter": "Аўтаварштат",
  "block.minecraft.crafting_table": "Варштат",
  "block.minecraft.creaking_heart": "Рыплівае сэрца",
  "block.minecraft.creeper_head": "Галава крыпера",
  "block.minecraft.creeper_wall_head": "Насценная галава крыпера",
  "block.minecraft.crimson_button": "Барвовая кнопка",
  "block.minecraft.crimson_door": "Барвовыя дзверы",
  "block.minecraft.crimson_fence": "Барвовы плот",
  "block.minecraft.crimson_fence_gate": "Барвовая брамка",
  "block.minecraft.crimson_fungus": "Барвовы грыб",
  "block.minecraft.crimson_hanging_sign": "Барвовая падвесная шыльда",
  "block.minecraft.crimson_hyphae": "Барвовыя гіфы",
  "block.minecraft.crimson_nylium": "Барвовы нілій",
  "block.minecraft.crimson_planks": "Барвовыя дошкі",
  "block.minecraft.crimson_pressure_plate": "Барвовая націскная пліта",
  "block.minecraft.crimson_roots": "Барвовыя карані",
  "block.minecraft.crimson_shelf": "Барвовая паліца",
  "block.minecraft.crimson_sign": "Барвовая шыльда",
  "block.minecraft.crimson_slab": "Барвовая пліта",
  "block.minecraft.crimson_stairs": "Барвовыя прыступкі",
  "block.minecraft.crimson_stem": "Барвовае сцябло",
  "block.minecraft.crimson_trapdoor": "Барвовы люк",
  "block.minecraft.crimson_wall_hanging_sign": "Барвовая насценная падвесная шыльда",
  "block.minecraft.crimson_wall_sign": "Барвовая насценная шыльда",
  "block.minecraft.crying_obsidian": "Плакучы абсідыян",
  "block.minecraft.cut_copper": "Разная медзь",
  "block.minecraft.cut_copper_slab": "Пліта з разной медзі",
  "block.minecraft.cut_copper_stairs": "Прыступкі з разной медзі",
  "block.minecraft.cut_red_sandstone": "Разны чырвоны пясчанік",
  "block.minecraft.cut_red_sandstone_slab": "Пліта з разнога чырвонага пясчаніку",
  "block.minecraft.cut_sandstone": "Разны пясчанік",
  "block.minecraft.cut_sandstone_slab": "Пліта з разнога пясчаніку",
  "block.minecraft.cyan_banner": "Бірузовы сцяг",
  "block.minecraft.cyan_bed": "Бірузовы ложак",
  "block.minecraft.cyan_candle": "Бірузовая свечка",
  "block.minecraft.cyan_candle_cake": "Торт з бірузовай свечкай",
  "block.minecraft.cyan_carpet": "Бірузовы дыван",
  "block.minecraft.cyan_concrete": "Бірузовы бетон",
  "block.minecraft.cyan_concrete_powder": "Бірузовы цэмент",
  "block.minecraft.cyan_glazed_terracotta": "Бірузовая паліваная кераміка",
  "block.minecraft.cyan_shulker_box": "Бірузовая шалкеравая скрыня",
  "block.minecraft.cyan_stained_glass": "Бірузовае шкло",
  "block.minecraft.cyan_stained_glass_pane": "Бірузовая шыба",
  "block.minecraft.cyan_terracotta": "Бірузовая кераміка",
  "block.minecraft.cyan_wool": "Бірузовая воўна",
  "block.minecraft.damaged_anvil": "Паламанае кавадла",
  "block.minecraft.dandelion": "Дзьмухавец",
  "block.minecraft.dark_oak_button": "Кнопка з цёмнага дубу",
  "block.minecraft.dark_oak_door": "Дзверы з цёмнага дубу",
  "block.minecraft.dark_oak_fence": "Плот з цёмнага дубу",
  "block.minecraft.dark_oak_fence_gate": "Брамка з цёмнага дубу",
  "block.minecraft.dark_oak_hanging_sign": "Падвесная шыльда з цёмнага дубу",
  "block.minecraft.dark_oak_leaves": "Лісце цёмнага дуба",
  "block.minecraft.dark_oak_log": "Бервяно цёмнага дуба",
  "block.minecraft.dark_oak_planks": "Дошкі з цёмнага дубу",
  "block.minecraft.dark_oak_pressure_plate": "Націскная пліта з цёмнага дубу",
  "block.minecraft.dark_oak_sapling": "Саджанец цёмнага дуба",
  "block.minecraft.dark_oak_shelf": "Паліца з цёмнага дубу",
  "block.minecraft.dark_oak_sign": "Шыльда з цёмнага дубу",
  "block.minecraft.dark_oak_slab": "Пліта з цёмнага дубу",
  "block.minecraft.dark_oak_stairs": "Прыступкі з цёмнага дубу",
  "block.minecraft.dark_oak_trapdoor": "Люк з цёмнага дубу",
  "block.minecraft.dark_oak_wall_hanging_sign": "Насценная падвесная шыльда з цёмнага дубу",
  "block.minecraft.dark_oak_wall_sign": "Насценная шыльда з цёмнага дубу",
  "block.minecraft.dark_oak_wood": "Драўніна цёмнага дуба",
  "block.minecraft.dark_prismarine": "Цёмны прызмарын",
  "block.minecraft.dark_prismarine_slab": "Пліта з цёмнага прызмарыну",
  "block.minecraft.dark_prismarine_stairs": "Цёмныя прызмарынавыя прыступкі",
  "block.minecraft.daylight_detector": "Датчык дзённага святла",
  "block.minecraft.dead_brain_coral": "Мёртвы мазгавы карал",
  "block.minecraft.dead_brain_coral_block": "Блок мёртвага мазгавога карала",
  "block.minecraft.dead_brain_coral_fan": "Мёртвы веерны мазгавы карал",
  "block.minecraft.dead_brain_coral_wall_fan": "Мёртвы гарызантальны веерны мазгавы карал",
  "block.minecraft.dead_bubble_coral": "Мёртвы пузырысты карал",
  "block.minecraft.dead_bubble_coral_block": "Блок мёртвага пузырыстага карала",
  "block.minecraft.dead_bubble_coral_fan": "Мёртвы веерны пузырысты карал",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мёртвы гарызантальны веерны пузырысты карал",
  "block.minecraft.dead_bush": "Мёртвы куст",
  "block.minecraft.dead_fire_coral": "Мёртвы агністы карал",
  "block.minecraft.dead_fire_coral_block": "Блок мёртвага агністага карала",
  "block.minecraft.dead_fire_coral_fan": "Мёртвы веерны агністы карал",
  "block.minecraft.dead_fire_coral_wall_fan": "Мёртвы гарызантальны веерны агністы карал",
  "block.minecraft.dead_horn_coral": "Мёртвы рагавы карал",
  "block.minecraft.dead_horn_coral_block": "Блок мёртвага рагавога карала",
  "block.minecraft.dead_horn_coral_fan": "Мёртвы веерны рагавы карал",
  "block.minecraft.dead_horn_coral_wall_fan": "Мёртвы гарызантальны веерны рагавы карал",
  "block.minecraft.dead_tube_coral": "Мёртвы трубчасты карал",
  "block.minecraft.dead_tube_coral_block": "Блок мёртвага трубчастага карала",
  "block.minecraft.dead_tube_coral_fan": "Мёртвы веерны трубчасты карал",
  "block.minecraft.dead_tube_coral_wall_fan": "Мёртвы гарызантальны веерны трубчасты карал",
  "block.minecraft.decorated_pot": "Дэкаратыўны гаршчок",
  "block.minecraft.deepslate": "Сланец",
  "block.minecraft.deepslate_brick_slab": "Пліта са сланцавай цэглы",
  "block.minecraft.deepslate_brick_stairs": "Прыступкі са сланцавай цэглы",
  "block.minecraft.deepslate_brick_wall": "Сцяна са сланцавай цэглы",
  "block.minecraft.deepslate_bricks": "Сланцавая цэгла",
  "block.minecraft.deepslate_coal_ore": "Вугальная руда глыбінь",
  "block.minecraft.deepslate_copper_ore": "Мядзяная руда глыбінь",
  "block.minecraft.deepslate_diamond_ore": "Дыяментавая руда глыбінь",
  "block.minecraft.deepslate_emerald_ore": "Смарагдавая руда глыбінь",
  "block.minecraft.deepslate_gold_ore": "Залатая руда глыбінь",
  "block.minecraft.deepslate_iron_ore": "Жалезная руда глыбінь",
  "block.minecraft.deepslate_lapis_ore": "Лазурытавая руда глыбінь",
  "block.minecraft.deepslate_redstone_ore": "Рэдстоўнавая руда глыбінь",
  "block.minecraft.deepslate_tile_slab": "Пліта са сланцавай кафлі",
  "block.minecraft.deepslate_tile_stairs": "Прыступкі са сланцавай кафлі",
  "block.minecraft.deepslate_tile_wall": "Сцяна са сланцавай кафлі",
  "block.minecraft.deepslate_tiles": "Сланцавая кафля",
  "block.minecraft.detector_rail": "Рэйкі з датчыкам",
  "block.minecraft.diamond_block": "Дыяментавы блок",
  "block.minecraft.diamond_ore": "Дыяментавая руда",
  "block.minecraft.diorite": "Дыярыт",
  "block.minecraft.diorite_slab": "Пліта з дыярыту",
  "block.minecraft.diorite_stairs": "Прыступкі з дыярыту",
  "block.minecraft.diorite_wall": "Сцяна з дыярыту",
  "block.minecraft.dirt": "Зямля",
  "block.minecraft.dirt_path": "Сцежка",
  "block.minecraft.dispenser": "Раздавальнік",
  "block.minecraft.dragon_egg": "Яйка цмока",
  "block.minecraft.dragon_head": "Галава цмока",
  "block.minecraft.dragon_wall_head": "Насценная галава цмока",
  "block.minecraft.dried_ghast": "Засмаглы гаст",
  "block.minecraft.dried_kelp_block": "Блок сушанай ламінарыі",
  "block.minecraft.dripstone_block": "Блок нацёку",
  "block.minecraft.dropper": "Выкідальнік",
  "block.minecraft.emerald_block": "Смарагдавы блок",
  "block.minecraft.emerald_ore": "Смарагдавая руда",
  "block.minecraft.enchanting_table": "Чараўніцкі стол",
  "block.minecraft.end_gateway": "Брама Энда",
  "block.minecraft.end_portal": "Партал у Энд",
  "block.minecraft.end_portal_frame": "Рамка партала ў Энд",
  "block.minecraft.end_rod": "Эндар-стрыжань",
  "block.minecraft.end_stone": "Камень Энда",
  "block.minecraft.end_stone_brick_slab": "Пліта з цэглы з каменю Энда",
  "block.minecraft.end_stone_brick_stairs": "Прыступкі з цэглы Энда",
  "block.minecraft.end_stone_brick_wall": "Сцяна з цэглы з каменю Энда",
  "block.minecraft.end_stone_bricks": "Цэгла з каменю Энда",
  "block.minecraft.ender_chest": "Эндар-куфар",
  "block.minecraft.exposed_chiseled_copper": "Пацьмянелая разьбяная медзь",
  "block.minecraft.exposed_copper": "Пацьмянелая медзь",
  "block.minecraft.exposed_copper_bars": "Пацьмянелыя мядзяныя краты",
  "block.minecraft.exposed_copper_bulb": "Пацьмянелая мядзяная лямпа",
  "block.minecraft.exposed_copper_chain": "Пацьмянелы мядзяны ланцуг",
  "block.minecraft.exposed_copper_chest": "Пацьмянелы мядзяны куфар",
  "block.minecraft.exposed_copper_door": "Пацьмянелыя мядзяныя дзверы",
  "block.minecraft.exposed_copper_golem_statue": "Пацьмянелая статуя мядзянага голема",
  "block.minecraft.exposed_copper_grate": "Пацьмянелая мядзяная рашотка",
  "block.minecraft.exposed_copper_lantern": "Пацьмянелы мядзяны ліхтар",
  "block.minecraft.exposed_copper_trapdoor": "Пацьмянелы мядзяны люк",
  "block.minecraft.exposed_cut_copper": "Пацьмянелая разная медзь",
  "block.minecraft.exposed_cut_copper_slab": "Пацьмянелая пліта з разной медзі",
  "block.minecraft.exposed_cut_copper_stairs": "Пацьмянелыя прыступкі з разной медзі",
  "block.minecraft.exposed_lightning_rod": "Пацьмянелы маланкаадвод",
  "block.minecraft.farmland": "Ралля",
  "block.minecraft.fern": "Папараць",
  "block.minecraft.fire": "Агонь",
  "block.minecraft.fire_coral": "Агністы карал",
  "block.minecraft.fire_coral_block": "Блок агністага карала",
  "block.minecraft.fire_coral_fan": "Веерны агністы карал",
  "block.minecraft.fire_coral_wall_fan": "Гарызантальны веерны агністы карал",
  "block.minecraft.firefly_bush": "Светлячковы куст",
  "block.minecraft.fletching_table": "Варштат лучніка",
  "block.minecraft.flower_pot": "Гаршчок",
  "block.minecraft.flowering_azalea": "Квітнеючая азалія",
  "block.minecraft.flowering_azalea_leaves": "Лісце квітнеючай азаліі",
  "block.minecraft.frogspawn": "Жабурынне",
  "block.minecraft.frosted_ice": "Талы лёд",
  "block.minecraft.furnace": "Печ",
  "block.minecraft.gilded_blackstone": "Пазалочаны чарніт",
  "block.minecraft.glass": "Шкло",
  "block.minecraft.glass_pane": "Шыба",
  "block.minecraft.glow_lichen": "Зіхатлівы лішайнік",
  "block.minecraft.glowstone": "Зіхатлівы камень",
  "block.minecraft.gold_block": "Залаты блок",
  "block.minecraft.gold_ore": "Залатая руда",
  "block.minecraft.golden_dandelion": "Залаты дзьмухавец",
  "block.minecraft.granite": "Граніт",
  "block.minecraft.granite_slab": "Пліта з граніту",
  "block.minecraft.granite_stairs": "Прыступкі з граніту",
  "block.minecraft.granite_wall": "Сцяна з граніту",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Зямля з дзёрнам",
  "block.minecraft.gravel": "Жвір",
  "block.minecraft.gray_banner": "Шэры сцяг",
  "block.minecraft.gray_bed": "Шэры ложак",
  "block.minecraft.gray_candle": "Шэрая свечка",
  "block.minecraft.gray_candle_cake": "Торт з шэрай свечкай",
  "block.minecraft.gray_carpet": "Шэры дыван",
  "block.minecraft.gray_concrete": "Шэры бетон",
  "block.minecraft.gray_concrete_powder": "Шэры цэмент",
  "block.minecraft.gray_glazed_terracotta": "Шэрая паліваная кераміка",
  "block.minecraft.gray_shulker_box": "Шэрая шалкеравая скрыня",
  "block.minecraft.gray_stained_glass": "Шэрае шкло",
  "block.minecraft.gray_stained_glass_pane": "Шэрая шыба",
  "block.minecraft.gray_terracotta": "Шэрая кераміка",
  "block.minecraft.gray_wool": "Шэрая воўна",
  "block.minecraft.green_banner": "Зялёны сцяг",
  "block.minecraft.green_bed": "Зялёны ложак",
  "block.minecraft.green_candle": "Зялёная свечка",
  "block.minecraft.green_candle_cake": "Торт з зялёнай свечкай",
  "block.minecraft.green_carpet": "Зялёны дыван",
  "block.minecraft.green_concrete": "Зялёны бетон",
  "block.minecraft.green_concrete_powder": "Зялёны цэмент",
  "block.minecraft.green_glazed_terracotta": "Зялёная паліваная кераміка",
  "block.minecraft.green_shulker_box": "Зялёная шалкеравая скрыня",
  "block.minecraft.green_stained_glass": "Зялёнае шкло",
  "block.minecraft.green_stained_glass_pane": "Зялёная шыба",
  "block.minecraft.green_terracotta": "Зялёная кераміка",
  "block.minecraft.green_wool": "Зялёная воўна",
  "block.minecraft.grindstone": "Шліфавальны круг",
  "block.minecraft.hanging_roots": "Вісячыя карані",
  "block.minecraft.hay_block": "Цюк сена",
  "block.minecraft.heavy_core": "Важкае ядро",
  "block.minecraft.heavy_weighted_pressure_plate": "Вагавая націскная пліта (цяжкая)",
  "block.minecraft.honey_block": "Блок мёду",
  "block.minecraft.honeycomb_block": "Блок мядовых сотаў",
  "block.minecraft.hopper": "Варонка",
  "block.minecraft.horn_coral": "Рагавы карал",
  "block.minecraft.horn_coral_block": "Блок рагавога карала",
  "block.minecraft.horn_coral_fan": "Веерны рагавы карал",
  "block.minecraft.horn_coral_wall_fan": "Гарызантальны веерны рагавы карал",
  "block.minecraft.ice": "Лёд",
  "block.minecraft.infested_chiseled_stone_bricks": "Заражаная разьбяная каменная цэгла",
  "block.minecraft.infested_cobblestone": "Заражаны бут",
  "block.minecraft.infested_cracked_stone_bricks": "Заражаная патрэсканая каменная цэгла",
  "block.minecraft.infested_deepslate": "Заражаны сланец",
  "block.minecraft.infested_mossy_stone_bricks": "Заражаная замшэлая каменная цэгла",
  "block.minecraft.infested_stone": "Заражаны камень",
  "block.minecraft.infested_stone_bricks": "Заражаная каменная цэгла",
  "block.minecraft.iron_bars": "Жалезныя краты",
  "block.minecraft.iron_block": "Жалезны блок",
  "block.minecraft.iron_chain": "Жалезны ланцуг",
  "block.minecraft.iron_door": "Жалезныя дзверы",
  "block.minecraft.iron_ore": "Жалезная руда",
  "block.minecraft.iron_trapdoor": "Жалезны люк",
  "block.minecraft.jack_o_lantern": "Свяцільня Джэка",
  "block.minecraft.jigsaw": "Канструкцыйны блок",
  "block.minecraft.jukebox": "Прайгравальнік",
  "block.minecraft.jungle_button": "Кнопка з трапічнай драўніны",
  "block.minecraft.jungle_door": "Дзверы з трапічнай драўніны",
  "block.minecraft.jungle_fence": "Плот з трапічнай драўніны",
  "block.minecraft.jungle_fence_gate": "Брамка з трапічнай драўніны",
  "block.minecraft.jungle_hanging_sign": "Падвесная шыльда з трапічнай драўніны",
  "block.minecraft.jungle_leaves": "Трапічнае лісце",
  "block.minecraft.jungle_log": "Бервяно трапічнага дрэва",
  "block.minecraft.jungle_planks": "Дошкі з трапічнай драўніны",
  "block.minecraft.jungle_pressure_plate": "Націскная пліта з трапічнай драўніны",
  "block.minecraft.jungle_sapling": "Саджанец трапічнага дрэва",
  "block.minecraft.jungle_shelf": "Паліца з трапічнай драўніны",
  "block.minecraft.jungle_sign": "Шыльда з трапічнай драўніны",
  "block.minecraft.jungle_slab": "Пліта з трапічнай драўніны",
  "block.minecraft.jungle_stairs": "Прыступкі з трапічнай драўніны",
  "block.minecraft.jungle_trapdoor": "Люк з трапічнай драўніны",
  "block.minecraft.jungle_wall_hanging_sign": "Насценная падвесная шыльда з трапічнай драўніны",
  "block.minecraft.jungle_wall_sign": "Насценная шыльда з трапічнай драўніны",
  "block.minecraft.jungle_wood": "Трапічная драўніна",
  "block.minecraft.kelp": "Ламінарыя",
  "block.minecraft.kelp_plant": "Сцябло ламінарыі",
  "block.minecraft.ladder": "Лесвіца",
  "block.minecraft.lantern": "Ліхтар",
  "block.minecraft.lapis_block": "Лазурытавы блок",
  "block.minecraft.lapis_ore": "Лазурытавая руда",
  "block.minecraft.large_amethyst_bud": "Вялікі зародак аметысту",
  "block.minecraft.large_fern": "Вялікая папараць",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Кацёл лавы",
  "block.minecraft.leaf_litter": "Сухое лісце",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Рычаг",
  "block.minecraft.light": "Святло",
  "block.minecraft.light_blue_banner": "Блакітны сцяг",
  "block.minecraft.light_blue_bed": "Блакітны ложак",
  "block.minecraft.light_blue_candle": "Блакітная свечка",
  "block.minecraft.light_blue_candle_cake": "Торт з блакітнай свечкай",
  "block.minecraft.light_blue_carpet": "Блакітны дыван",
  "block.minecraft.light_blue_concrete": "Блакітны бетон",
  "block.minecraft.light_blue_concrete_powder": "Блакітны цэмент",
  "block.minecraft.light_blue_glazed_terracotta": "Блакітная паліваная кераміка",
  "block.minecraft.light_blue_shulker_box": "Блакітная шалкеравая скрыня",
  "block.minecraft.light_blue_stained_glass": "Блакітнае шкло",
  "block.minecraft.light_blue_stained_glass_pane": "Блакітная шыба",
  "block.minecraft.light_blue_terracotta": "Блакітная кераміка",
  "block.minecraft.light_blue_wool": "Блакітная воўна",
  "block.minecraft.light_gray_banner": "Светла-шэры сцяг",
  "block.minecraft.light_gray_bed": "Светла-шэры ложак",
  "block.minecraft.light_gray_candle": "Светла-шэрая свечка",
  "block.minecraft.light_gray_candle_cake": "Торт з светла-шэрай свечкай",
  "block.minecraft.light_gray_carpet": "Светла-шэры дыван",
  "block.minecraft.light_gray_concrete": "Светла-шэры бетон",
  "block.minecraft.light_gray_concrete_powder": "Светла-шэры цэмент",
  "block.minecraft.light_gray_glazed_terracotta": "Светла-шэрая паліваная кераміка",
  "block.minecraft.light_gray_shulker_box": "Светла-шэрая шалкеравая скрыня",
  "block.minecraft.light_gray_stained_glass": "Светла-шэрае шкло",
  "block.minecraft.light_gray_stained_glass_pane": "Светла-шэрая шыба",
  "block.minecraft.light_gray_terracotta": "Светла-шэрая кераміка",
  "block.minecraft.light_gray_wool": "Светла-шэрая воўна",
  "block.minecraft.light_weighted_pressure_plate": "Вагавая націскная пліта (лёгкая)",
  "block.minecraft.lightning_rod": "Маланкаадвод",
  "block.minecraft.lilac": "Бэз",
  "block.minecraft.lily_of_the_valley": "Ландыш",
  "block.minecraft.lily_pad": "Гарлачык",
  "block.minecraft.lime_banner": "Лаймавы сцяг",
  "block.minecraft.lime_bed": "Лаймавы ложак",
  "block.minecraft.lime_candle": "Лаймавая свечка",
  "block.minecraft.lime_candle_cake": "Торт з лаймавай свечкай",
  "block.minecraft.lime_carpet": "Лаймавы дыван",
  "block.minecraft.lime_concrete": "Лаймавы бетон",
  "block.minecraft.lime_concrete_powder": "Лаймавы цэмент",
  "block.minecraft.lime_glazed_terracotta": "Лаймавая паліваная кераміка",
  "block.minecraft.lime_shulker_box": "Лаймавая шалкеравая скрыня",
  "block.minecraft.lime_stained_glass": "Лаймавае шкло",
  "block.minecraft.lime_stained_glass_pane": "Лаймавая шыба",
  "block.minecraft.lime_terracotta": "Лаймавая кераміка",
  "block.minecraft.lime_wool": "Лаймавая воўна",
  "block.minecraft.lodestone": "Магнетыт",
  "block.minecraft.loom": "Кросны",
  "block.minecraft.magenta_banner": "Пурпурны сцяг",
  "block.minecraft.magenta_bed": "Пурпурны ложак",
  "block.minecraft.magenta_candle": "Пурпурная свечка",
  "block.minecraft.magenta_candle_cake": "Торт з пурпурнай свечкай",
  "block.minecraft.magenta_carpet": "Пурпурны дыван",
  "block.minecraft.magenta_concrete": "Пурпурны бетон",
  "block.minecraft.magenta_concrete_powder": "Пурпурны цэмент",
  "block.minecraft.magenta_glazed_terracotta": "Пурпурная паліваная кераміка",
  "block.minecraft.magenta_shulker_box": "Пурпурная шалкеравая скрыня",
  "block.minecraft.magenta_stained_glass": "Пурпурнае шкло",
  "block.minecraft.magenta_stained_glass_pane": "Пурпурная шыба",
  "block.minecraft.magenta_terracotta": "Пурпурная кераміка",
  "block.minecraft.magenta_wool": "Пурпурная воўна",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Кнопка з мангравай драўніны",
  "block.minecraft.mangrove_door": "Дзверы з мангравай драўніны",
  "block.minecraft.mangrove_fence": "Плот з мангравай драўніны",
  "block.minecraft.mangrove_fence_gate": "Брамка з мангравай драўніны",
  "block.minecraft.mangrove_hanging_sign": "Падвесная шыльда з мангравай драўніны",
  "block.minecraft.mangrove_leaves": "Мангравае лісце",
  "block.minecraft.mangrove_log": "Мангравае бервяно",
  "block.minecraft.mangrove_planks": "Дошкі з мангравай драўніны",
  "block.minecraft.mangrove_pressure_plate": "Націскная пліта з мангравай драўніны",
  "block.minecraft.mangrove_propagule": "Мангравая прапагула",
  "block.minecraft.mangrove_roots": "Карані мангравага дрэва",
  "block.minecraft.mangrove_shelf": "Паліца з мангравай драўніны",
  "block.minecraft.mangrove_sign": "Шыльда з мангравай драўніны",
  "block.minecraft.mangrove_slab": "Пліта з мангравай драўніны",
  "block.minecraft.mangrove_stairs": "Прыступкі з мангравай драўніны",
  "block.minecraft.mangrove_trapdoor": "Люк з мангравай драўніны",
  "block.minecraft.mangrove_wall_hanging_sign": "Насценная падвесная шыльда з мангравай драўніны",
  "block.minecraft.mangrove_wall_sign": "Насценная шыльда з мангравай драўніны",
  "block.minecraft.mangrove_wood": "Мангравая драўніна",
  "block.minecraft.medium_amethyst_bud": "Сярэдні зародак аметысту",
  "block.minecraft.melon": "Кавун",
  "block.minecraft.melon_stem": "Сцябло кавуна",
  "block.minecraft.moss_block": "Блок імху",
  "block.minecraft.moss_carpet": "Імховы дыван",
  "block.minecraft.mossy_cobblestone": "Замшэлы бут",
  "block.minecraft.mossy_cobblestone_slab": "Замшэлая пліта з буту",
  "block.minecraft.mossy_cobblestone_stairs": "Замшэлыя прыступкі з буту",
  "block.minecraft.mossy_cobblestone_wall": "Сцяна з замшэлага буту",
  "block.minecraft.mossy_stone_brick_slab": "Замшэлая пліта з каменнай цэглы",
  "block.minecraft.mossy_stone_brick_stairs": "Замшэлыя прыступкі з каменнай цэглы",
  "block.minecraft.mossy_stone_brick_wall": "Замшэлая сцяна з каменнай цэглы",
  "block.minecraft.mossy_stone_bricks": "Замшэлая каменная цэгла",
  "block.minecraft.moving_piston": "Поршань у руху",
  "block.minecraft.mud": "Гразь",
  "block.minecraft.mud_brick_slab": "Пліта з саманавай цэглы",
  "block.minecraft.mud_brick_stairs": "Прыступкі з саманавай цэглы",
  "block.minecraft.mud_brick_wall": "Сцяна з саманавай цэглы",
  "block.minecraft.mud_bricks": "Саманавая цэгла",
  "block.minecraft.muddy_mangrove_roots": "Гразкія карані мангравага дрэва",
  "block.minecraft.mushroom_stem": "Ножка грыба",
  "block.minecraft.mycelium": "Міцэлій",
  "block.minecraft.nether_brick_fence": "Плот з нэдарскай цэглы",
  "block.minecraft.nether_brick_slab": "Пліта з нэдарскай цэглы",
  "block.minecraft.nether_brick_stairs": "Прыступкі з нэдарскай цэглы",
  "block.minecraft.nether_brick_wall": "Сцяна з нэдарскай цэглы",
  "block.minecraft.nether_bricks": "Нэдарская цэгла",
  "block.minecraft.nether_gold_ore": "Нэдарская залатая руда",
  "block.minecraft.nether_portal": "Партал у Нэдар",
  "block.minecraft.nether_quartz_ore": "Кварцавая руда",
  "block.minecraft.nether_sprouts": "Нэдарскія парасткі",
  "block.minecraft.nether_wart": "Нэдарская нарасць",
  "block.minecraft.nether_wart_block": "Блок нэдарскай нарасці",
  "block.minecraft.netherite_block": "Нэдарытавы блок",
  "block.minecraft.netherrack": "Нэдаррэк",
  "block.minecraft.note_block": "Нотны блок",
  "block.minecraft.oak_button": "Дубовая кнопка",
  "block.minecraft.oak_door": "Дубовыя дзверы",
  "block.minecraft.oak_fence": "Дубовы плот",
  "block.minecraft.oak_fence_gate": "Дубовая брамка",
  "block.minecraft.oak_hanging_sign": "Дубовая падвесная шыльда",
  "block.minecraft.oak_leaves": "Дубовае лісце",
  "block.minecraft.oak_log": "Дубовае бервяно",
  "block.minecraft.oak_planks": "Дубовыя дошкі",
  "block.minecraft.oak_pressure_plate": "Дубовая націскная пліта",
  "block.minecraft.oak_sapling": "Саджанец дуба",
  "block.minecraft.oak_shelf": "Дубовая паліца",
  "block.minecraft.oak_sign": "Дубовая шыльда",
  "block.minecraft.oak_slab": "Дубовая пліта",
  "block.minecraft.oak_stairs": "Дубовыя прыступкі",
  "block.minecraft.oak_trapdoor": "Дубовы люк",
  "block.minecraft.oak_wall_hanging_sign": "Дубовая насценная падвесная шыльда",
  "block.minecraft.oak_wall_sign": "Дубовая насценная шыльда",
  "block.minecraft.oak_wood": "Дубовая драўніна",
  "block.minecraft.observer": "Назіральнік",
  "block.minecraft.obsidian": "Абсідыян",
  "block.minecraft.ochre_froglight": "Вохравае жабінае святло",
  "block.minecraft.ominous_banner": "Злавесны сцяг",
  "block.minecraft.open_eyeblossom": "Адкрыты вокацвет",
  "block.minecraft.orange_banner": "Аранжавы сцяг",
  "block.minecraft.orange_bed": "Аранжавы ложак",
  "block.minecraft.orange_candle": "Аранжавая свечка",
  "block.minecraft.orange_candle_cake": "Торт з аранжавай свечкай",
  "block.minecraft.orange_carpet": "Аранжавы дыван",
  "block.minecraft.orange_concrete": "Аранжавы бетон",
  "block.minecraft.orange_concrete_powder": "Аранжавы цэмент",
  "block.minecraft.orange_glazed_terracotta": "Аранжавая паліваная кераміка",
  "block.minecraft.orange_shulker_box": "Аранжавая шалкеравая скрыня",
  "block.minecraft.orange_stained_glass": "Аранжавае шкло",
  "block.minecraft.orange_stained_glass_pane": "Аранжавая шыба",
  "block.minecraft.orange_terracotta": "Аранжавая кераміка",
  "block.minecraft.orange_tulip": "Аранжавы цюльпан",
  "block.minecraft.orange_wool": "Аранжавая воўна",
  "block.minecraft.oxeye_daisy": "Цюцюпан",
  "block.minecraft.oxidized_chiseled_copper": "Акісленая разьбяная медзь",
  "block.minecraft.oxidized_copper": "Акісленая медзь",
  "block.minecraft.oxidized_copper_bars": "Акісленыя мядзяныя краты",
  "block.minecraft.oxidized_copper_bulb": "Акісленая мядзяная лямпа",
  "block.minecraft.oxidized_copper_chain": "Акіслены мядзяны ланцуг",
  "block.minecraft.oxidized_copper_chest": "Акіслены мядзяны куфар",
  "block.minecraft.oxidized_copper_door": "Акісленыя мядзяныя дзверы",
  "block.minecraft.oxidized_copper_golem_statue": "Акісленая статуя мядзянага голема",
  "block.minecraft.oxidized_copper_grate": "Акісленая мядзяная рашотка",
  "block.minecraft.oxidized_copper_lantern": "Акіслены мядзяны ліхтар",
  "block.minecraft.oxidized_copper_trapdoor": "Акіслены мядзяны люк",
  "block.minecraft.oxidized_cut_copper": "Акісленая разная медзь",
  "block.minecraft.oxidized_cut_copper_slab": "Акісленая пліта з разной медзі",
  "block.minecraft.oxidized_cut_copper_stairs": "Акісленыя прыступкі з разной медзі",
  "block.minecraft.oxidized_lightning_rod": "Акіслены маланкаадвод",
  "block.minecraft.packed_ice": "Шчыльны лёд",
  "block.minecraft.packed_mud": "Шчыльная гразь",
  "block.minecraft.pale_hanging_moss": "Бледны вісячы мох",
  "block.minecraft.pale_moss_block": "Блок бледнага імху",
  "block.minecraft.pale_moss_carpet": "Бледны імховы дыван",
  "block.minecraft.pale_oak_button": "Кнопка з бледнага дубу",
  "block.minecraft.pale_oak_door": "Дзверы з бледнага дубу",
  "block.minecraft.pale_oak_fence": "Плот з бледнага дубу",
  "block.minecraft.pale_oak_fence_gate": "Брамка з бледнага дубу",
  "block.minecraft.pale_oak_hanging_sign": "Падвесная шыльда з бледнага дубу",
  "block.minecraft.pale_oak_leaves": "Лісце бледнага дуба",
  "block.minecraft.pale_oak_log": "Бервяно бледнага дуба",
  "block.minecraft.pale_oak_planks": "Дошкі з бледнага дубу",
  "block.minecraft.pale_oak_pressure_plate": "Націскная пліта з бледнага дубу",
  "block.minecraft.pale_oak_sapling": "Саджанец бледнага дуба",
  "block.minecraft.pale_oak_shelf": "Паліца з бледнага дубу",
  "block.minecraft.pale_oak_sign": "Шыльда з бледнага дубу",
  "block.minecraft.pale_oak_slab": "Пліта з бледнага дубу",
  "block.minecraft.pale_oak_stairs": "Прыступкі з бледнага дубу",
  "block.minecraft.pale_oak_trapdoor": "Люк з бледнага дубу",
  "block.minecraft.pale_oak_wall_hanging_sign": "Насценная падвесная шыльда з бледнага дубу",
  "block.minecraft.pale_oak_wall_sign": "Насценная шыльда з бледнага дубу",
  "block.minecraft.pale_oak_wood": "Драўніна бледнага дуба",
  "block.minecraft.pearlescent_froglight": "Перламутравае жабінае святло",
  "block.minecraft.peony": "Півоня",
  "block.minecraft.petrified_oak_slab": "Акамянелая дубовая пліта",
  "block.minecraft.piglin_head": "Галава пігліна",
  "block.minecraft.piglin_wall_head": "Насценная галава пігліна",
  "block.minecraft.pink_banner": "Ружовы сцяг",
  "block.minecraft.pink_bed": "Ружовы ложак",
  "block.minecraft.pink_candle": "Ружовая свечка",
  "block.minecraft.pink_candle_cake": "Торт з ружовай свечкай",
  "block.minecraft.pink_carpet": "Ружовы дыван",
  "block.minecraft.pink_concrete": "Ружовы бетон",
  "block.minecraft.pink_concrete_powder": "Ружовы цэмент",
  "block.minecraft.pink_glazed_terracotta": "Ружовая паліваная кераміка",
  "block.minecraft.pink_petals": "Ружовыя пялёсткі",
  "block.minecraft.pink_shulker_box": "Ружовая шалкеравая скрыня",
  "block.minecraft.pink_stained_glass": "Ружовае шкло",
  "block.minecraft.pink_stained_glass_pane": "Ружовая шыба",
  "block.minecraft.pink_terracotta": "Ружовая кераміка",
  "block.minecraft.pink_tulip": "Ружовы цюльпан",
  "block.minecraft.pink_wool": "Ружовая воўна",
  "block.minecraft.piston": "Поршань",
  "block.minecraft.piston_head": "Паверхня поршня",
  "block.minecraft.pitcher_crop": "Парастак гладышніка",
  "block.minecraft.pitcher_plant": "Гладышнік",
  "block.minecraft.player_head": "Галава гульца",
  "block.minecraft.player_head.named": "Галава %s",
  "block.minecraft.player_wall_head": "Насценная галава гульца",
  "block.minecraft.podzol": "Падзол",
  "block.minecraft.pointed_dripstone": "Завостраны нацёк",
  "block.minecraft.polished_andesite": "Паліраваны андэзіт",
  "block.minecraft.polished_andesite_slab": "Пліта з паліраванага андэзіту",
  "block.minecraft.polished_andesite_stairs": "Прыступкі з паліраванага андэзіту",
  "block.minecraft.polished_basalt": "Паліраваны базальт",
  "block.minecraft.polished_blackstone": "Паліраваны чарніт",
  "block.minecraft.polished_blackstone_brick_slab": "Пліта з паліраванай чарнітавай цэглы",
  "block.minecraft.polished_blackstone_brick_stairs": "Прыступкі з паліраванай чарнітавай цэглы",
  "block.minecraft.polished_blackstone_brick_wall": "Сцяна з паліраванай чарнітавай цэглы",
  "block.minecraft.polished_blackstone_bricks": "Цэгла з паліраванага чарніту",
  "block.minecraft.polished_blackstone_button": "Паліраваная кнопка з чарніту",
  "block.minecraft.polished_blackstone_pressure_plate": "Націскная пліта з паліраванага чарніту",
  "block.minecraft.polished_blackstone_slab": "Пліта з паліраванага чарніту",
  "block.minecraft.polished_blackstone_stairs": "Прыступкі з паліраванага чарніту",
  "block.minecraft.polished_blackstone_wall": "Сцяна з паліраванага чарніту",
  "block.minecraft.polished_deepslate": "Паліраваны сланец",
  "block.minecraft.polished_deepslate_slab": "Пліта з паліраванага сланцу",
  "block.minecraft.polished_deepslate_stairs": "Прыступкі з паліраванага сланцу",
  "block.minecraft.polished_deepslate_wall": "Сцяна з паліраванага сланцу",
  "block.minecraft.polished_diorite": "Паліраваны дыярыт",
  "block.minecraft.polished_diorite_slab": "Пліта з паліраванага дыярыту",
  "block.minecraft.polished_diorite_stairs": "Прыступкі з паліраванага дыярыту",
  "block.minecraft.polished_granite": "Паліраваны граніт",
  "block.minecraft.polished_granite_slab": "Пліта з паліраванага граніту",
  "block.minecraft.polished_granite_stairs": "Прыступкі з паліраванага граніту",
  "block.minecraft.polished_tuff": "Паліраваны туф",
  "block.minecraft.polished_tuff_slab": "Пліта з паліраванага туфу",
  "block.minecraft.polished_tuff_stairs": "Прыступкі з паліраванага туфу",
  "block.minecraft.polished_tuff_wall": "Сцяна з паліраванага туфу",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Бульба",
  "block.minecraft.potted_acacia_sapling": "Саджанец акацыі ў гаршку",
  "block.minecraft.potted_allium": "Цыбуля ў гаршку",
  "block.minecraft.potted_azalea_bush": "Азалія ў гаршку",
  "block.minecraft.potted_azure_bluet": "Хаўстонія блакітная ў гаршку",
  "block.minecraft.potted_bamboo": "Бамбук у гаршку",
  "block.minecraft.potted_birch_sapling": "Саджанец бярозы ў гаршку",
  "block.minecraft.potted_blue_orchid": "Блакітная архідэя ў гаршку",
  "block.minecraft.potted_brown_mushroom": "Баравік у гаршку",
  "block.minecraft.potted_cactus": "Кактус у гаршку",
  "block.minecraft.potted_cherry_sapling": "Саджанец вішні ў гаршку",
  "block.minecraft.potted_closed_eyeblossom": "Закрыты вокацвет у гаршку",
  "block.minecraft.potted_cornflower": "Валошка ў гаршку",
  "block.minecraft.potted_crimson_fungus": "Барвовы грыб у гаршку",
  "block.minecraft.potted_crimson_roots": "Барвовыя карані ў гаршку",
  "block.minecraft.potted_dandelion": "Дзьмухавец у гаршку",
  "block.minecraft.potted_dark_oak_sapling": "Саджанец цёмнага дуба ў гаршку",
  "block.minecraft.potted_dead_bush": "Мёртвы куст у гаршку",
  "block.minecraft.potted_fern": "Папараць у гаршку",
  "block.minecraft.potted_flowering_azalea_bush": "Квітнеючая азалія ў гаршку",
  "block.minecraft.potted_golden_dandelion": "Залаты дзьмухавец у гаршку",
  "block.minecraft.potted_jungle_sapling": "Саджанец трапічнага дрэва ў гаршку",
  "block.minecraft.potted_lily_of_the_valley": "Ландыш у гаршку",
  "block.minecraft.potted_mangrove_propagule": "Мангравая прапагула ў гаршку",
  "block.minecraft.potted_oak_sapling": "Саджанец дуба ў гаршку",
  "block.minecraft.potted_open_eyeblossom": "Адкрыты вокацвет у гаршку",
  "block.minecraft.potted_orange_tulip": "Аранжавы цюльпан у гаршку",
  "block.minecraft.potted_oxeye_daisy": "Цюцюпан у гаршку",
  "block.minecraft.potted_pale_oak_sapling": "Саджанец бледнага дуба ў гаршку",
  "block.minecraft.potted_pink_tulip": "Ружовы цюльпан у гаршку",
  "block.minecraft.potted_poppy": "Мак у гаршку",
  "block.minecraft.potted_red_mushroom": "Мухамор у гаршку",
  "block.minecraft.potted_red_tulip": "Чырвоны цюльпан у гаршку",
  "block.minecraft.potted_spruce_sapling": "Саджанец елкі ў гаршку",
  "block.minecraft.potted_torchflower": "Палымяная лілея ў гаршку",
  "block.minecraft.potted_warped_fungus": "Скажоны грыб у гаршку",
  "block.minecraft.potted_warped_roots": "Скажоныя карані ў гаршку",
  "block.minecraft.potted_white_tulip": "Белы цюльпан у гаршку",
  "block.minecraft.potted_wither_rose": "Ружа відара ў гаршку",
  "block.minecraft.powder_snow": "Сыпкі снег",
  "block.minecraft.powder_snow_cauldron": "Кацёл сыпкага снегу",
  "block.minecraft.powered_rail": "Энергарэйкі",
  "block.minecraft.prismarine": "Прызмарын",
  "block.minecraft.prismarine_brick_slab": "Пліта з прызмарынавай цэглы",
  "block.minecraft.prismarine_brick_stairs": "Прыступкі з прызмарынавай цэглы",
  "block.minecraft.prismarine_bricks": "Прызмарынавая цэгла",
  "block.minecraft.prismarine_slab": "Пліта з прызмарыну",
  "block.minecraft.prismarine_stairs": "Прызмарынавыя прыступкі",
  "block.minecraft.prismarine_wall": "Сцяна з прызмарыну",
  "block.minecraft.pumpkin": "Гарбуз",
  "block.minecraft.pumpkin_stem": "Сцябло гарбуза",
  "block.minecraft.purple_banner": "Фіялетавы сцяг",
  "block.minecraft.purple_bed": "Фіялетавы ложак",
  "block.minecraft.purple_candle": "Фіялетавая свечка",
  "block.minecraft.purple_candle_cake": "Торт з фіялетавай свечкай",
  "block.minecraft.purple_carpet": "Фіялетавы дыван",
  "block.minecraft.purple_concrete": "Фіялетавы бетон",
  "block.minecraft.purple_concrete_powder": "Фіялетавы цэмент",
  "block.minecraft.purple_glazed_terracotta": "Фіялетавая паліваная кераміка",
  "block.minecraft.purple_shulker_box": "Фіялетавая шалкеравая скрыня",
  "block.minecraft.purple_stained_glass": "Фіялетавае шкло",
  "block.minecraft.purple_stained_glass_pane": "Фіялетавая шыба",
  "block.minecraft.purple_terracotta": "Фіялетавая кераміка",
  "block.minecraft.purple_wool": "Фіялетавая воўна",
  "block.minecraft.purpur_block": "Блок пурпуру",
  "block.minecraft.purpur_pillar": "Пурпуровая калона",
  "block.minecraft.purpur_slab": "Пурпуровая пліта",
  "block.minecraft.purpur_stairs": "Пурпуровыя прыступкі",
  "block.minecraft.quartz_block": "Кварцавы блок",
  "block.minecraft.quartz_bricks": "Кварцавая цэгла",
  "block.minecraft.quartz_pillar": "Кварцавая калона",
  "block.minecraft.quartz_slab": "Кварцавая пліта",
  "block.minecraft.quartz_stairs": "Кварцавыя прыступкі",
  "block.minecraft.rail": "Рэйкі",
  "block.minecraft.raw_copper_block": "Блок сырой медзі",
  "block.minecraft.raw_gold_block": "Блок сырога золата",
  "block.minecraft.raw_iron_block": "Блок сырога жалеза",
  "block.minecraft.red_banner": "Чырвоны сцяг",
  "block.minecraft.red_bed": "Чырвоны ложак",
  "block.minecraft.red_candle": "Чырвоная свечка",
  "block.minecraft.red_candle_cake": "Торт з чырвонай свечкай",
  "block.minecraft.red_carpet": "Чырвоны дыван",
  "block.minecraft.red_concrete": "Чырвоны бетон",
  "block.minecraft.red_concrete_powder": "Чырвоны цэмент",
  "block.minecraft.red_glazed_terracotta": "Чырвоная паліваная кераміка",
  "block.minecraft.red_mushroom": "Мухамор",
  "block.minecraft.red_mushroom_block": "Блок мухамора",
  "block.minecraft.red_nether_brick_slab": "Пліта з чырвонай нэдарскай цэглы",
  "block.minecraft.red_nether_brick_stairs": "Прыступкі з чырвонай нэдарскай цэглы",
  "block.minecraft.red_nether_brick_wall": "Сцяна з чырвонай нэдарскай цэглы",
  "block.minecraft.red_nether_bricks": "Чырвоная нэдарская цэгла",
  "block.minecraft.red_sand": "Чырвоны пясок",
  "block.minecraft.red_sandstone": "Чырвоны пясчанік",
  "block.minecraft.red_sandstone_slab": "Пліта з чырвонага пясчаніку",
  "block.minecraft.red_sandstone_stairs": "Прыступкі з чырвонага пясчаніку",
  "block.minecraft.red_sandstone_wall": "Сцяна з чырвонага пясчаніку",
  "block.minecraft.red_shulker_box": "Чырвоная шалкеравая скрыня",
  "block.minecraft.red_stained_glass": "Чырвонае шкло",
  "block.minecraft.red_stained_glass_pane": "Чырвоная шыба",
  "block.minecraft.red_terracotta": "Чырвоная кераміка",
  "block.minecraft.red_tulip": "Чырвоны цюльпан",
  "block.minecraft.red_wool": "Чырвоная воўна",
  "block.minecraft.redstone_block": "Блок рэдстоўну",
  "block.minecraft.redstone_lamp": "Рэдстоўнавая лямпа",
  "block.minecraft.redstone_ore": "Рэдстоўнавая руда",
  "block.minecraft.redstone_torch": "Рэдстоўнавы факел",
  "block.minecraft.redstone_wall_torch": "Насценны рэдстоўнавы факел",
  "block.minecraft.redstone_wire": "Рэдстоўнавы провад",
  "block.minecraft.reinforced_deepslate": "Узмоцнены сланец",
  "block.minecraft.repeater": "Паўтаральнік",
  "block.minecraft.repeating_command_block": "Паўторны камандны блок",
  "block.minecraft.resin_block": "Смаляны блок",
  "block.minecraft.resin_brick_slab": "Пліта са смаляной цэглы",
  "block.minecraft.resin_brick_stairs": "Прыступкі са смаляной цэглы",
  "block.minecraft.resin_brick_wall": "Сцяна са смаляной цэглы",
  "block.minecraft.resin_bricks": "Смаляная цэгла",
  "block.minecraft.resin_clump": "Згустак смалы",
  "block.minecraft.respawn_anchor": "Котва адраджэння",
  "block.minecraft.rooted_dirt": "Караністая зямля",
  "block.minecraft.rose_bush": "Ружовы куст",
  "block.minecraft.sand": "Пясок",
  "block.minecraft.sandstone": "Пясчанік",
  "block.minecraft.sandstone_slab": "Пліта з пясчаніку",
  "block.minecraft.sandstone_stairs": "Прыступкі з пясчаніку",
  "block.minecraft.sandstone_wall": "Сцяна з пясчаніку",
  "block.minecraft.scaffolding": "Рыштаванні",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалкавы каталізатар",
  "block.minecraft.sculk_sensor": "Скалкавы сэнсар",
  "block.minecraft.sculk_shrieker": "Скалкавы віскун",
  "block.minecraft.sculk_vein": "Скалкавая жыла",
  "block.minecraft.sea_lantern": "Марскі ліхтар",
  "block.minecraft.sea_pickle": "Агняцелка",
  "block.minecraft.seagrass": "Марская трава",
  "block.minecraft.set_spawn": "Пункт адраджэння ўсталяваны",
  "block.minecraft.short_dry_grass": "Нізкая сухая трава",
  "block.minecraft.short_grass": "Нізкая трава",
  "block.minecraft.shroomlight": "Святлагрыб",
  "block.minecraft.shulker_box": "Шалкеравая скрыня",
  "block.minecraft.skeleton_skull": "Чэрап",
  "block.minecraft.skeleton_wall_skull": "Насценны чэрап",
  "block.minecraft.slime_block": "Блок слізі",
  "block.minecraft.small_amethyst_bud": "Маленькі зародак аметысту",
  "block.minecraft.small_dripleaf": "Маленькі кропляліст",
  "block.minecraft.smithing_table": "Варштат каваля",
  "block.minecraft.smoker": "Вяндлярня",
  "block.minecraft.smooth_basalt": "Гладкі базальт",
  "block.minecraft.smooth_quartz": "Блок гладкага кварцу",
  "block.minecraft.smooth_quartz_slab": "Пліта з гладкага кварцу",
  "block.minecraft.smooth_quartz_stairs": "Прыступкі з гладкага кварцу",
  "block.minecraft.smooth_red_sandstone": "Гладкі чырвоны пясчанік",
  "block.minecraft.smooth_red_sandstone_slab": "Пліта з гладкага чырвонага пясчаніку",
  "block.minecraft.smooth_red_sandstone_stairs": "Прыступкі з гладкага чырвонага пясчаніку",
  "block.minecraft.smooth_sandstone": "Гладкі пясчанік",
  "block.minecraft.smooth_sandstone_slab": "Пліта з гладкага пясчаніку",
  "block.minecraft.smooth_sandstone_stairs": "Прыступкі з гладкага пясчаніку",
  "block.minecraft.smooth_stone": "Гладкі камень",
  "block.minecraft.smooth_stone_slab": "Пліта з гладкага каменя",
  "block.minecraft.sniffer_egg": "Яйка нюхача",
  "block.minecraft.snow": "Снег",
  "block.minecraft.snow_block": "Блок снегу",
  "block.minecraft.soul_campfire": "Вогнішча душ",
  "block.minecraft.soul_fire": "Агонь душ",
  "block.minecraft.soul_lantern": "Ліхтар душ",
  "block.minecraft.soul_sand": "Пясок душ",
  "block.minecraft.soul_soil": "Глеба душ",
  "block.minecraft.soul_torch": "Факел душ",
  "block.minecraft.soul_wall_torch": "Насценны факел душ",
  "block.minecraft.spawn.not_valid": "У вас няма ложка або заладаванай котвы адраджэння, альбо доступ да іх страчан",
  "block.minecraft.spawner": "Рассаднік пачвар",
  "block.minecraft.spawner.desc1": "Узаемадзеянняў з яйкам выкліку:",
  "block.minecraft.spawner.desc2": "Задае тып істоты",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Кветка са спорамі",
  "block.minecraft.spruce_button": "Яловая кнопка",
  "block.minecraft.spruce_door": "Яловыя дзверы",
  "block.minecraft.spruce_fence": "Яловы плот",
  "block.minecraft.spruce_fence_gate": "Яловая брамка",
  "block.minecraft.spruce_hanging_sign": "Яловая падвесная шыльда",
  "block.minecraft.spruce_leaves": "Ігліца",
  "block.minecraft.spruce_log": "Яловае бервяно",
  "block.minecraft.spruce_planks": "Яловыя дошкі",
  "block.minecraft.spruce_pressure_plate": "Яловая націскная пліта",
  "block.minecraft.spruce_sapling": "Саджанец елкі",
  "block.minecraft.spruce_shelf": "Яловая паліца",
  "block.minecraft.spruce_sign": "Яловая шыльда",
  "block.minecraft.spruce_slab": "Яловая пліта",
  "block.minecraft.spruce_stairs": "Яловыя прыступкі",
  "block.minecraft.spruce_trapdoor": "Яловы люк",
  "block.minecraft.spruce_wall_hanging_sign": "Яловая насценная падвесная шыльда",
  "block.minecraft.spruce_wall_sign": "Яловая насценная шыльда",
  "block.minecraft.spruce_wood": "Яловая драўніна",
  "block.minecraft.sticky_piston": "Ліпкі поршань",
  "block.minecraft.stone": "Камень",
  "block.minecraft.stone_brick_slab": "Пліта з каменнай цэглы",
  "block.minecraft.stone_brick_stairs": "Прыступкі з каменнай цэглы",
  "block.minecraft.stone_brick_wall": "Сцяна з каменнай цэглы",
  "block.minecraft.stone_bricks": "Каменная цэгла",
  "block.minecraft.stone_button": "Каменная кнопка",
  "block.minecraft.stone_pressure_plate": "Каменная націскная пліта",
  "block.minecraft.stone_slab": "Каменная пліта",
  "block.minecraft.stone_stairs": "Каменныя прыступкі",
  "block.minecraft.stonecutter": "Каменярэз",
  "block.minecraft.stripped_acacia_log": "Абчасанае бервяно акацыі",
  "block.minecraft.stripped_acacia_wood": "Абчасаная драўніна акацыі",
  "block.minecraft.stripped_bamboo_block": "Блок абчасанага бамбуку",
  "block.minecraft.stripped_birch_log": "Абчасанае бярозавае бервяно",
  "block.minecraft.stripped_birch_wood": "Абчасаная бярозавая драўніна",
  "block.minecraft.stripped_cherry_log": "Абчасанае вішнёвае бервяно",
  "block.minecraft.stripped_cherry_wood": "Абчасаная вішнёвая драўніна",
  "block.minecraft.stripped_crimson_hyphae": "Абчасаныя барвовыя гіфы",
  "block.minecraft.stripped_crimson_stem": "Абчасанае барвовае сцябло",
  "block.minecraft.stripped_dark_oak_log": "Абчасанае бервяно цёмнага дуба",
  "block.minecraft.stripped_dark_oak_wood": "Абчасаная драўніна цёмнага дуба",
  "block.minecraft.stripped_jungle_log": "Абчасанае бервяно трапічнага дрэва",
  "block.minecraft.stripped_jungle_wood": "Абчасаная трапічная драўніна",
  "block.minecraft.stripped_mangrove_log": "Абчасанае мангравае бервяно",
  "block.minecraft.stripped_mangrove_wood": "Абчасаная мангравая драўніна",
  "block.minecraft.stripped_oak_log": "Абчасанае дубовае бервяно",
  "block.minecraft.stripped_oak_wood": "Абчасаная дубовая драўніна",
  "block.minecraft.stripped_pale_oak_log": "Абчасанае бервяно бледнага дуба",
  "block.minecraft.stripped_pale_oak_wood": "Абчасаная драўніна бледнага дуба",
  "block.minecraft.stripped_spruce_log": "Абчасанае яловае бервяно",
  "block.minecraft.stripped_spruce_wood": "Абчасаная яловая драўніна",
  "block.minecraft.stripped_warped_hyphae": "Абчасаныя скажоныя гіфы",
  "block.minecraft.stripped_warped_stem": "Абчасанае скажонае сцябло",
  "block.minecraft.structure_block": "Структурны блок",
  "block.minecraft.structure_void": "Пустата",
  "block.minecraft.sugar_cane": "Цукровы трыснёг",
  "block.minecraft.sunflower": "Сланечнік",
  "block.minecraft.suspicious_gravel": "Падазроны жвір",
  "block.minecraft.suspicious_sand": "Падазроны пясок",
  "block.minecraft.sweet_berry_bush": "Куст салодкіх ягад",
  "block.minecraft.tall_dry_grass": "Высокая сухая трава",
  "block.minecraft.tall_grass": "Высокая трава",
  "block.minecraft.tall_seagrass": "Высокая марская трава",
  "block.minecraft.target": "Мішэнь",
  "block.minecraft.terracotta": "Кераміка",
  "block.minecraft.test_block": "Тэставы блок",
  "block.minecraft.test_instance_block": "Блок тэставага асобніка",
  "block.minecraft.tinted_glass": "Таніраванае шкло",
  "block.minecraft.tnt": "Дынаміт",
  "block.minecraft.tnt.disabled": "Выбухі дынаміту адключаны",
  "block.minecraft.torch": "Факел",
  "block.minecraft.torchflower": "Палымяная лілея",
  "block.minecraft.torchflower_crop": "Парастак палымянай лілеі",
  "block.minecraft.trapped_chest": "Куфар-пастка",
  "block.minecraft.trial_spawner": "Рассаднік выпрабаванняў",
  "block.minecraft.tripwire": "Расцяжка",
  "block.minecraft.tripwire_hook": "Крук",
  "block.minecraft.tube_coral": "Трубчасты карал",
  "block.minecraft.tube_coral_block": "Блок трубчастага карала",
  "block.minecraft.tube_coral_fan": "Веерны трубчасты карал",
  "block.minecraft.tube_coral_wall_fan": "Гарызантальны веерны трубчасты карал",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Пліта з туфавай цэглы",
  "block.minecraft.tuff_brick_stairs": "Прыступкі з туфавай цэглы",
  "block.minecraft.tuff_brick_wall": "Сцяна з туфавай цэглы",
  "block.minecraft.tuff_bricks": "Туфавая цэгла",
  "block.minecraft.tuff_slab": "Пліта з туфу",
  "block.minecraft.tuff_stairs": "Прыступкі з туфу",
  "block.minecraft.tuff_wall": "Сцяна з туфу",
  "block.minecraft.turtle_egg": "Яйка чарапахі",
  "block.minecraft.twisting_vines": "Пакручастыя лозы",
  "block.minecraft.twisting_vines_plant": "Сцябло пакручастай лазы",
  "block.minecraft.vault": "Скарбніца",
  "block.minecraft.verdant_froglight": "Малахітавае жабінае святло",
  "block.minecraft.vine": "Лаза",
  "block.minecraft.void_air": "Пустэчнае паветра",
  "block.minecraft.wall_torch": "Насценны факел",
  "block.minecraft.warped_button": "Скажоная кнопка",
  "block.minecraft.warped_door": "Скажоныя дзверы",
  "block.minecraft.warped_fence": "Скажоны плот",
  "block.minecraft.warped_fence_gate": "Скажоная брамка",
  "block.minecraft.warped_fungus": "Скажоны грыб",
  "block.minecraft.warped_hanging_sign": "Скажоная падвесная шыльда",
  "block.minecraft.warped_hyphae": "Скажоныя гіфы",
  "block.minecraft.warped_nylium": "Скажоны нілій",
  "block.minecraft.warped_planks": "Скажоныя дошкі",
  "block.minecraft.warped_pressure_plate": "Скажоная націскная пліта",
  "block.minecraft.warped_roots": "Скажоныя карані",
  "block.minecraft.warped_shelf": "Скажоная паліца",
  "block.minecraft.warped_sign": "Скажоная шыльда",
  "block.minecraft.warped_slab": "Скажоная пліта",
  "block.minecraft.warped_stairs": "Скажоныя прыступкі",
  "block.minecraft.warped_stem": "Скажонае сцябло",
  "block.minecraft.warped_trapdoor": "Скажоны люк",
  "block.minecraft.warped_wall_hanging_sign": "Скажоная насценная падвесная шыльда",
  "block.minecraft.warped_wall_sign": "Скажоная насценная шыльда",
  "block.minecraft.warped_wart_block": "Блок скажонай нэдарскай нарасці",
  "block.minecraft.water": "Вада",
  "block.minecraft.water_cauldron": "Кацёл вады",
  "block.minecraft.waxed_chiseled_copper": "Васкаваная разьбяная медзь",
  "block.minecraft.waxed_copper_bars": "Васкаваныя мядзяныя краты",
  "block.minecraft.waxed_copper_block": "Васкаваны мядзяны блок",
  "block.minecraft.waxed_copper_bulb": "Васкаваная мядзяная лямпа",
  "block.minecraft.waxed_copper_chain": "Васкаваны мядзяны ланцуг",
  "block.minecraft.waxed_copper_chest": "Васкаваны мядзяны куфар",
  "block.minecraft.waxed_copper_door": "Васкаваныя мядзяныя дзверы",
  "block.minecraft.waxed_copper_golem_statue": "Васкаваная статуя мядзянага голема",
  "block.minecraft.waxed_copper_grate": "Васкаваная мядзяная рашотка",
  "block.minecraft.waxed_copper_lantern": "Васкаваны мядзяны ліхтар",
  "block.minecraft.waxed_copper_trapdoor": "Васкаваны мядзяны люк",
  "block.minecraft.waxed_cut_copper": "Васкаваная разная медзь",
  "block.minecraft.waxed_cut_copper_slab": "Васкаваная пліта з разной медзі",
  "block.minecraft.waxed_cut_copper_stairs": "Васкаваныя прыступкі з разной медзі",
  "block.minecraft.waxed_exposed_chiseled_copper": "Васкаваная пацьмянелая разьбяная медзь",
  "block.minecraft.waxed_exposed_copper": "Васкаваная пацьмянелая медзь",
  "block.minecraft.waxed_exposed_copper_bars": "Васкаваныя пацьмянелыя мядзяныя краты",
  "block.minecraft.waxed_exposed_copper_bulb": "Васкаваная пацьмянелая мядзяная лямпа",
  "block.minecraft.waxed_exposed_copper_chain": "Васкаваны пацьмянелы мядзяны ланцуг",
  "block.minecraft.waxed_exposed_copper_chest": "Васкаваны пацьмянелы мядзяны куфар",
  "block.minecraft.waxed_exposed_copper_door": "Васкаваныя пацьмянелыя мядзяныя дзверы",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Васкаваная пацьмянелая статуя мядзянага голема",
  "block.minecraft.waxed_exposed_copper_grate": "Васкаваная пацьмянелая мядзяная рашотка",
  "block.minecraft.waxed_exposed_copper_lantern": "Васкаваны пацьмянелы мядзяны ліхтар",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Васкаваны пацьмянелы мядзяны люк",
  "block.minecraft.waxed_exposed_cut_copper": "Васкаваная пацьмянелая разная медзь",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Васкаваная пацьмянелая пліта з разной медзі",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Васкаваныя пацьмянелыя прыступкі з разной медзі",
  "block.minecraft.waxed_exposed_lightning_rod": "Васкаваны пацьмянелы маланкаадвод",
  "block.minecraft.waxed_lightning_rod": "Васкаваны маланкаадвод",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Васкаваная акісленая разьбяная медзь",
  "block.minecraft.waxed_oxidized_copper": "Васкаваная акісленая медзь",
  "block.minecraft.waxed_oxidized_copper_bars": "Васкаваныя акісленыя мядзяныя краты",
  "block.minecraft.waxed_oxidized_copper_bulb": "Васкаваная акісленая мядзяная лямпа",
  "block.minecraft.waxed_oxidized_copper_chain": "Васкаваны акіслены мядзяны ланцуг",
  "block.minecraft.waxed_oxidized_copper_chest": "Васкаваны акіслены мядзяны куфар",
  "block.minecraft.waxed_oxidized_copper_door": "Васкаваныя акісленыя мядзяныя дзверы",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Васкаваная акісленая статуя мядзянага голема",
  "block.minecraft.waxed_oxidized_copper_grate": "Васкаваная акісленая мядзяная рашотка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Васкаваны акіслены мядзяны ліхтар",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Васкаваны акіслены мядзяны люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Васкаваная акісленая разная медзь",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Васкаваная акісленая пліта з разной медзі",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Васкаваныя акісленыя прыступкі з разной медзі",
  "block.minecraft.waxed_oxidized_lightning_rod": "Васкаваны акіслены маланкаадвод",
  "block.minecraft.waxed_weathered_chiseled_copper": "Васкаваная выветраная разьбяная медзь",
  "block.minecraft.waxed_weathered_copper": "Васкаваная выветраная медзь",
  "block.minecraft.waxed_weathered_copper_bars": "Васкаваныя выветраныя мядзяныя краты",
  "block.minecraft.waxed_weathered_copper_bulb": "Васкаваная выветраная мядзяная лямпа",
  "block.minecraft.waxed_weathered_copper_chain": "Васкаваны выветраны мядзяны ланцуг",
  "block.minecraft.waxed_weathered_copper_chest": "Васкаваны выветраны мядзяны куфар",
  "block.minecraft.waxed_weathered_copper_door": "Васкаваныя выветраныя мядзяныя дзверы",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Васкаваная выветраная статуя мядзянага голема",
  "block.minecraft.waxed_weathered_copper_grate": "Васкаваная выветраная мядзяная рашотка",
  "block.minecraft.waxed_weathered_copper_lantern": "Васкаваны выветраны мядзяны ліхтар",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Васкаваны выветраны мядзяны люк",
  "block.minecraft.waxed_weathered_cut_copper": "Васкаваная выветраная разная медзь",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Васкаваная выветраная пліта з разной медзі",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Васкаваныя выветраныя прыступкі з разной медзі",
  "block.minecraft.waxed_weathered_lightning_rod": "Васкаваны выветраны маланкаадвод",
  "block.minecraft.weathered_chiseled_copper": "Выветраная разьбяная медзь",
  "block.minecraft.weathered_copper": "Выветраная медзь",
  "block.minecraft.weathered_copper_bars": "Выветраныя мядзяныя краты",
  "block.minecraft.weathered_copper_bulb": "Выветраная мядзяная лямпа",
  "block.minecraft.weathered_copper_chain": "Выветраны мядзяны ланцуг",
  "block.minecraft.weathered_copper_chest": "Выветраны мядзяны куфар",
  "block.minecraft.weathered_copper_door": "Выветраныя мядзяныя дзверы",
  "block.minecraft.weathered_copper_golem_statue": "Выветраная статуя мядзянага голема",
  "block.minecraft.weathered_copper_grate": "Выветраная мядзяная рашотка",
  "block.minecraft.weathered_copper_lantern": "Выветраны мядзяны ліхтар",
  "block.minecraft.weathered_copper_trapdoor": "Выветраны мядзяны люк",
  "block.minecraft.weathered_cut_copper": "Выветраная разная медзь",
  "block.minecraft.weathered_cut_copper_slab": "Пліта з выветранай разной медзі",
  "block.minecraft.weathered_cut_copper_stairs": "Прыступкі з выветранай разной медзі",
  "block.minecraft.weathered_lightning_rod": "Выветраны маланкаадвод",
  "block.minecraft.weeping_vines": "Ніцыя лозы",
  "block.minecraft.weeping_vines_plant": "Сцябло ніцай лазы",
  "block.minecraft.wet_sponge": "Мокрая губка",
  "block.minecraft.wheat": "Парасткі пшаніцы",
  "block.minecraft.white_banner": "Белы сцяг",
  "block.minecraft.white_bed": "Белы ложак",
  "block.minecraft.white_candle": "Белая свечка",
  "block.minecraft.white_candle_cake": "Торт з белай свечкай",
  "block.minecraft.white_carpet": "Белы дыван",
  "block.minecraft.white_concrete": "Белы бетон",
  "block.minecraft.white_concrete_powder": "Белы цэмент",
  "block.minecraft.white_glazed_terracotta": "Белая паліваная кераміка",
  "block.minecraft.white_shulker_box": "Белая шалкеравая скрыня",
  "block.minecraft.white_stained_glass": "Белае шкло",
  "block.minecraft.white_stained_glass_pane": "Белая шыба",
  "block.minecraft.white_terracotta": "Белая кераміка",
  "block.minecraft.white_tulip": "Белы цюльпан",
  "block.minecraft.white_wool": "Белая воўна",
  "block.minecraft.wildflowers": "Палявыя кветкі",
  "block.minecraft.wither_rose": "Ружа відара",
  "block.minecraft.wither_skeleton_skull": "Чэрап відар-шкілета",
  "block.minecraft.wither_skeleton_wall_skull": "Насценны чэрап відар-шкілета",
  "block.minecraft.yellow_banner": "Жоўты сцяг",
  "block.minecraft.yellow_bed": "Жоўты ложак",
  "block.minecraft.yellow_candle": "Жоўтая свечка",
  "block.minecraft.yellow_candle_cake": "Торт з жоўтай свечкай",
  "block.minecraft.yellow_carpet": "Жоўты дыван",
  "block.minecraft.yellow_concrete": "Жоўты бетон",
  "block.minecraft.yellow_concrete_powder": "Жоўты цэмент",
  "block.minecraft.yellow_glazed_terracotta": "Жоўтая паліваная кераміка",
  "block.minecraft.yellow_shulker_box": "Жоўтая шалкеравая скрыня",
  "block.minecraft.yellow_stained_glass": "Жоўтае шкло",
  "block.minecraft.yellow_stained_glass_pane": "Жоўтая шыба",
  "block.minecraft.yellow_terracotta": "Жоўтая кераміка",
  "block.minecraft.yellow_wool": "Жоўтая воўна",
  "block.minecraft.zombie_head": "Галава мерцвяка",
  "block.minecraft.zombie_wall_head": "Насценная галава мерцвяка",
  "item.minecraft.acacia_boat": "Човен з акацыі",
  "item.minecraft.acacia_chest_boat": "Човен з акацыі з куфрам",
  "item.minecraft.allay_spawn_egg": "Яйка выкліку — Спакаёўка",
  "item.minecraft.amethyst_shard": "Асколак аметысту",
  "item.minecraft.angler_pottery_shard": "Ганчарны чарапок «Рыбалоў»",
  "item.minecraft.angler_pottery_sherd": "Ганчарны чарапок «Рыбалоў»",
  "item.minecraft.apple": "Яблык",
  "item.minecraft.archer_pottery_shard": "Ганчарны чарапок «Лучнік»",
  "item.minecraft.archer_pottery_sherd": "Ганчарны чарапок «Лучнік»",
  "item.minecraft.armadillo_scute": "Лускавінка браняносца",
  "item.minecraft.armadillo_spawn_egg": "Яйка выкліку — Браняносец",
  "item.minecraft.armor_stand": "Стойка для брані",
  "item.minecraft.arms_up_pottery_shard": "Ганчарны чарапок «Рукі ўгору»",
  "item.minecraft.arms_up_pottery_sherd": "Ганчарны чарапок «Рукі ўгору»",
  "item.minecraft.arrow": "Страла",
  "item.minecraft.axolotl_bucket": "Вядро з аксалотлем",
  "item.minecraft.axolotl_spawn_egg": "Яйка выкліку — Аксалотль",
  "item.minecraft.baked_potato": "Печаная бульба",
  "item.minecraft.bamboo_chest_raft": "Бамбукавы плыт з куфрам",
  "item.minecraft.bamboo_raft": "Бамбукавы плыт",
  "item.minecraft.bat_spawn_egg": "Яйка выкліку — Кажан",
  "item.minecraft.bee_spawn_egg": "Яйка выкліку — Пчала",
  "item.minecraft.beef": "Сырая ялавічына",
  "item.minecraft.beetroot": "Бурак",
  "item.minecraft.beetroot_seeds": "Насенне бурака",
  "item.minecraft.beetroot_soup": "Боршч",
  "item.minecraft.birch_boat": "Бярозавы човен",
  "item.minecraft.birch_chest_boat": "Бярозавы човен з куфрам",
  "item.minecraft.black_bundle": "Чорны мех",
  "item.minecraft.black_dye": "Чорны фарбавальнік",
  "item.minecraft.black_harness": "Чорная вупраж",
  "item.minecraft.blade_pottery_shard": "Ганчарны чарапок «Лязо»",
  "item.minecraft.blade_pottery_sherd": "Ганчарны чарапок «Лязо»",
  "item.minecraft.blaze_powder": "Вогненны парашок",
  "item.minecraft.blaze_rod": "Вогненны стрыжань",
  "item.minecraft.blaze_spawn_egg": "Яйка выкліку — Полымень",
  "item.minecraft.blue_bundle": "Сіні мех",
  "item.minecraft.blue_dye": "Сіні фарбавальнік",
  "item.minecraft.blue_egg": "Блакітнае яйка",
  "item.minecraft.blue_harness": "Сіняя вупраж",
  "item.minecraft.bogged_spawn_egg": "Яйка выкліку — Дрыгвяк",
  "item.minecraft.bolt_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Арнамент «Ніт»",
  "item.minecraft.bone": "Косць",
  "item.minecraft.bone_meal": "Касцявая мука",
  "item.minecraft.book": "Кніга",
  "item.minecraft.bordure_indented_banner_pattern": "Шаблон сцяга «Зубчастая ліштва»",
  "item.minecraft.bow": "Лук",
  "item.minecraft.bowl": "Міска",
  "item.minecraft.bread": "Хлеб",
  "item.minecraft.breeze_rod": "Ветравы стрыжань",
  "item.minecraft.breeze_spawn_egg": "Яйка выкліку — Ветрык",
  "item.minecraft.brewer_pottery_shard": "Ганчарны чарапок «Алхімік»",
  "item.minecraft.brewer_pottery_sherd": "Ганчарны чарапок «Алхімік»",
  "item.minecraft.brewing_stand": "Варачная стойка",
  "item.minecraft.brick": "Цагліна",
  "item.minecraft.brown_bundle": "Карычневы мех",
  "item.minecraft.brown_dye": "Карычневы фарбавальнік",
  "item.minecraft.brown_egg": "Карычневае яйка",
  "item.minecraft.brown_harness": "Карычневая вупраж",
  "item.minecraft.brush": "Пэндзаль",
  "item.minecraft.bucket": "Вядро",
  "item.minecraft.bundle": "Мех",
  "item.minecraft.bundle.empty": "Пусты",
  "item.minecraft.bundle.empty.description": "Можа мясціць стос розных прадметаў",
  "item.minecraft.bundle.full": "Поўны",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Ганчарны чарапок «Полымя»",
  "item.minecraft.burn_pottery_sherd": "Ганчарны чарапок «Полымя»",
  "item.minecraft.camel_husk_spawn_egg": "Яйка выкліку — Вярблюд-здыхляк",
  "item.minecraft.camel_spawn_egg": "Яйка выкліку — Вярблюд",
  "item.minecraft.carrot": "Морква",
  "item.minecraft.carrot_on_a_stick": "Морква на палачцы",
  "item.minecraft.cat_spawn_egg": "Яйка выкліку — Кот",
  "item.minecraft.cauldron": "Кацёл",
  "item.minecraft.cave_spider_spawn_egg": "Яйка выкліку — Пячорны павук",
  "item.minecraft.chainmail_boots": "Кальчужныя боты",
  "item.minecraft.chainmail_chestplate": "Кальчужны нагруднік",
  "item.minecraft.chainmail_helmet": "Кальчужны шлем",
  "item.minecraft.chainmail_leggings": "Кальчужныя понажы",
  "item.minecraft.charcoal": "Драўняны вугаль",
  "item.minecraft.cherry_boat": "Човен з вішнёвай драўніны",
  "item.minecraft.cherry_chest_boat": "Човен з вішнёвай драўніны з куфрам",
  "item.minecraft.chest_minecart": "Ваганетка з куфрам",
  "item.minecraft.chicken": "Сырая кураціна",
  "item.minecraft.chicken_spawn_egg": "Яйка выкліку — Курыца",
  "item.minecraft.chorus_fruit": "Плод хоруса",
  "item.minecraft.clay_ball": "Камяк гліны",
  "item.minecraft.clock": "Гадзіннік",
  "item.minecraft.coal": "Вугаль",
  "item.minecraft.coast_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Арнамент «Узбярэжжа»",
  "item.minecraft.cocoa_beans": "Какава-бабы",
  "item.minecraft.cod": "Сырая траска",
  "item.minecraft.cod_bucket": "Вядро з траской",
  "item.minecraft.cod_spawn_egg": "Яйка выкліку — Траска",
  "item.minecraft.command_block_minecart": "Ваганетка з камандным блокам",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Смажаная ялавічына",
  "item.minecraft.cooked_chicken": "Смажаная кураціна",
  "item.minecraft.cooked_cod": "Смажаная траска",
  "item.minecraft.cooked_mutton": "Смажаная бараніна",
  "item.minecraft.cooked_porkchop": "Смажаная свініна",
  "item.minecraft.cooked_rabbit": "Смажаная трусяціна",
  "item.minecraft.cooked_salmon": "Смажаны ласось",
  "item.minecraft.cookie": "Печыва",
  "item.minecraft.copper_axe": "Мядзяная сякера",
  "item.minecraft.copper_boots": "Мядзяныя боты",
  "item.minecraft.copper_chestplate": "Мядзяная кіраса",
  "item.minecraft.copper_golem_spawn_egg": "Яйка выкліку — Мядзяны голем",
  "item.minecraft.copper_helmet": "Мядзяны шлем",
  "item.minecraft.copper_hoe": "Мядзяная матыка",
  "item.minecraft.copper_horse_armor": "Мядзяная конская браня",
  "item.minecraft.copper_ingot": "Мядзяны злітак",
  "item.minecraft.copper_leggings": "Мядзяныя понажы",
  "item.minecraft.copper_nautilus_armor": "Мядзяная наўтылусава браня",
  "item.minecraft.copper_nugget": "Кавалак медзі",
  "item.minecraft.copper_pickaxe": "Мядзяная кірка",
  "item.minecraft.copper_shovel": "Мядзяная рыдлёўка",
  "item.minecraft.copper_spear": "Мядзяная дзіда",
  "item.minecraft.copper_sword": "Мядзяны меч",
  "item.minecraft.cow_spawn_egg": "Яйка выкліку — Карова",
  "item.minecraft.creaking_spawn_egg": "Яйка выкліку — Рыпень",
  "item.minecraft.creeper_banner_pattern": "Шаблон сцяга",
  "item.minecraft.creeper_banner_pattern.desc": "Твар крыпера",
  "item.minecraft.creeper_banner_pattern.new": "Шаблон сцяга «Крыпер»",
  "item.minecraft.creeper_spawn_egg": "Яйка выкліку — Крыпер",
  "item.minecraft.crossbow": "Самастрэл",
  "item.minecraft.crossbow.projectile": "Снарад:",
  "item.minecraft.crossbow.projectile.multiple": "Снарад: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Снарад: %s",
  "item.minecraft.cyan_bundle": "Бірузовы мех",
  "item.minecraft.cyan_dye": "Бірузовы фарбавальнік",
  "item.minecraft.cyan_harness": "Бірузовая вупраж",
  "item.minecraft.danger_pottery_shard": "Ганчарны чарапок «Пагроза»",
  "item.minecraft.danger_pottery_sherd": "Ганчарны чарапок «Пагроза»",
  "item.minecraft.dark_oak_boat": "Човен з цёмнага дубу",
  "item.minecraft.dark_oak_chest_boat": "Човен з цёмнага дубу з куфрам",
  "item.minecraft.debug_stick": "Палачка адладкі",
  "item.minecraft.debug_stick.empty": "У %s няма ўласцівасцяў",
  "item.minecraft.debug_stick.select": "выбрана «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» у %s",
  "item.minecraft.diamond": "Дыямент",
  "item.minecraft.diamond_axe": "Дыяментавая сякера",
  "item.minecraft.diamond_boots": "Дыяментавыя боты",
  "item.minecraft.diamond_chestplate": "Дыяментавая кіраса",
  "item.minecraft.diamond_helmet": "Дыяментавы шлем",
  "item.minecraft.diamond_hoe": "Дыяментавая матыка",
  "item.minecraft.diamond_horse_armor": "Дыяментавая конская браня",
  "item.minecraft.diamond_leggings": "Дыяментавыя понажы",
  "item.minecraft.diamond_nautilus_armor": "Дыяментавая наўтылусава браня",
  "item.minecraft.diamond_pickaxe": "Дыяментавая кірка",
  "item.minecraft.diamond_shovel": "Дыяментавая рыдлёўка",
  "item.minecraft.diamond_spear": "Дыяментавая дзіда",
  "item.minecraft.diamond_sword": "Дыяментавы меч",
  "item.minecraft.disc_fragment_5": "Фрагмент грампласцінкі",
  "item.minecraft.disc_fragment_5.desc": "Грампласцінка — 5",
  "item.minecraft.dolphin_spawn_egg": "Яйка выкліку — Дэльфін",
  "item.minecraft.donkey_spawn_egg": "Яйка выкліку — Асёл",
  "item.minecraft.dragon_breath": "Дыханне цмока",
  "item.minecraft.dried_kelp": "Сушаная ламінарыя",
  "item.minecraft.drowned_spawn_egg": "Яйка выкліку — Тапелец",
  "item.minecraft.dune_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Арнамент «Выдма»",
  "item.minecraft.echo_shard": "Асколак рэха",
  "item.minecraft.egg": "Яйка",
  "item.minecraft.elder_guardian_spawn_egg": "Яйка выкліку — Старажытны вартавы",
  "item.minecraft.elytra": "Элітры",
  "item.minecraft.emerald": "Смарагд",
  "item.minecraft.enchanted_book": "Зачараваная кніга",
  "item.minecraft.enchanted_golden_apple": "Зачараваны залаты яблык",
  "item.minecraft.end_crystal": "Крышталь Энда",
  "item.minecraft.ender_dragon_spawn_egg": "Яйка выкліку — Эндар-цмок",
  "item.minecraft.ender_eye": "Вока Эндара",
  "item.minecraft.ender_pearl": "Жамчужына Энда",
  "item.minecraft.enderman_spawn_egg": "Яйка выкліку — Эндармэн",
  "item.minecraft.endermite_spawn_egg": "Яйка выкліку — Эндармайт",
  "item.minecraft.evoker_spawn_egg": "Яйка выкліку — Заклінальнік",
  "item.minecraft.experience_bottle": "Пляшка досведу",
  "item.minecraft.explorer_pottery_shard": "Ганчарны чарапок «Даследчык»",
  "item.minecraft.explorer_pottery_sherd": "Ганчарны чарапок «Даследчык»",
  "item.minecraft.eye_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Арнамент «Вока»",
  "item.minecraft.feather": "Пяро",
  "item.minecraft.fermented_spider_eye": "Марынаванае павучынае вока",
  "item.minecraft.field_masoned_banner_pattern": "Шаблон сцяга «Мур»",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "Вогненны шар",
  "item.minecraft.firework_rocket": "Феерверк",
  "item.minecraft.firework_rocket.flight": "Працягласць палёту:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Набой феерверку",
  "item.minecraft.firework_star.black": "Чорны",
  "item.minecraft.firework_star.blue": "Сіні",
  "item.minecraft.firework_star.brown": "Карычневы",
  "item.minecraft.firework_star.custom_color": "Карыстальніцкі",
  "item.minecraft.firework_star.cyan": "Бірузовы",
  "item.minecraft.firework_star.fade_to": "Пераходзіць у",
  "item.minecraft.firework_star.flicker": "Мільгаценне",
  "item.minecraft.firework_star.gray": "Шэры",
  "item.minecraft.firework_star.green": "Зялёны",
  "item.minecraft.firework_star.light_blue": "Блакітны",
  "item.minecraft.firework_star.light_gray": "Светла-шэры",
  "item.minecraft.firework_star.lime": "Лаймавы",
  "item.minecraft.firework_star.magenta": "Пурпурны",
  "item.minecraft.firework_star.orange": "Аранжавы",
  "item.minecraft.firework_star.pink": "Ружовы",
  "item.minecraft.firework_star.purple": "Фіялетавы",
  "item.minecraft.firework_star.red": "Чырвоны",
  "item.minecraft.firework_star.shape": "Невядомая форма",
  "item.minecraft.firework_star.shape.burst": "Выбух",
  "item.minecraft.firework_star.shape.creeper": "Крыперападобны",
  "item.minecraft.firework_star.shape.large_ball": "Вялікі шар",
  "item.minecraft.firework_star.shape.small_ball": "Маленькі шар",
  "item.minecraft.firework_star.shape.star": "Зоркападобны",
  "item.minecraft.firework_star.trail": "След",
  "item.minecraft.firework_star.white": "Белы",
  "item.minecraft.firework_star.yellow": "Жоўты",
  "item.minecraft.fishing_rod": "Вуда",
  "item.minecraft.flint": "Крэмень",
  "item.minecraft.flint_and_steel": "Крэсіва",
  "item.minecraft.flow_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Арнамент «Плынь»",
  "item.minecraft.flow_banner_pattern": "Шаблон сцяга",
  "item.minecraft.flow_banner_pattern.desc": "Плынь",
  "item.minecraft.flow_banner_pattern.new": "Шаблон сцяга «Плынь»",
  "item.minecraft.flow_pottery_sherd": "Ганчарны чарапок «Плынь»",
  "item.minecraft.flower_banner_pattern": "Шаблон сцяга",
  "item.minecraft.flower_banner_pattern.desc": "Кветка",
  "item.minecraft.flower_banner_pattern.new": "Шаблон сцяга «Кветка»",
  "item.minecraft.flower_pot": "Гаршчок",
  "item.minecraft.fox_spawn_egg": "Яйка выкліку — Ліс",
  "item.minecraft.friend_pottery_shard": "Ганчарны чарапок «Сябар»",
  "item.minecraft.friend_pottery_sherd": "Ганчарны чарапок «Сябар»",
  "item.minecraft.frog_spawn_egg": "Яйка выкліку — Жаба",
  "item.minecraft.furnace_minecart": "Ваганетка з печчу",
  "item.minecraft.ghast_spawn_egg": "Яйка выкліку — Гаст",
  "item.minecraft.ghast_tear": "Сляза гаста",
  "item.minecraft.glass_bottle": "Шкляная пляшка",
  "item.minecraft.glistering_melon_slice": "Зіхатлівы кавалак кавуна",
  "item.minecraft.globe_banner_pattern": "Шаблон сцяга",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "Шаблон сцяга «Глобус»",
  "item.minecraft.glow_berries": "Зіхатлівыя ягады",
  "item.minecraft.glow_ink_sac": "Зіхатлівы чарнільны мяшок",
  "item.minecraft.glow_item_frame": "Зіхатлівая рамка",
  "item.minecraft.glow_squid_spawn_egg": "Яйка выкліку — Зіхатлівы спрут",
  "item.minecraft.glowstone_dust": "Зіхатлівы пыл",
  "item.minecraft.goat_horn": "Казіны рог",
  "item.minecraft.goat_spawn_egg": "Яйка выкліку — Каза",
  "item.minecraft.gold_ingot": "Залаты злітак",
  "item.minecraft.gold_nugget": "Кавалак золата",
  "item.minecraft.golden_apple": "Залаты яблык",
  "item.minecraft.golden_axe": "Залатая сякера",
  "item.minecraft.golden_boots": "Залатыя боты",
  "item.minecraft.golden_carrot": "Залатая морква",
  "item.minecraft.golden_chestplate": "Залатая кіраса",
  "item.minecraft.golden_helmet": "Залаты шлем",
  "item.minecraft.golden_hoe": "Залатая матыка",
  "item.minecraft.golden_horse_armor": "Залатая конская браня",
  "item.minecraft.golden_leggings": "Залатыя понажы",
  "item.minecraft.golden_nautilus_armor": "Залатая наўтылусава браня",
  "item.minecraft.golden_pickaxe": "Залатая кірка",
  "item.minecraft.golden_shovel": "Залатая рыдлёўка",
  "item.minecraft.golden_spear": "Залатая дзіда",
  "item.minecraft.golden_sword": "Залаты меч",
  "item.minecraft.gray_bundle": "Шэры мех",
  "item.minecraft.gray_dye": "Шэры фарбавальнік",
  "item.minecraft.gray_harness": "Шэрая вупраж",
  "item.minecraft.green_bundle": "Зялёны мех",
  "item.minecraft.green_dye": "Зялёны фарбавальнік",
  "item.minecraft.green_harness": "Зялёная вупраж",
  "item.minecraft.guardian_spawn_egg": "Яйка выкліку — Вартавы",
  "item.minecraft.gunpowder": "Порах",
  "item.minecraft.guster_banner_pattern": "Шаблон сцяга",
  "item.minecraft.guster_banner_pattern.desc": "Парыў",
  "item.minecraft.guster_banner_pattern.new": "Шаблон сцяга «Парыў»",
  "item.minecraft.guster_pottery_sherd": "Ганчарны чарапок «Парыў»",
  "item.minecraft.happy_ghast_spawn_egg": "Яйка выкліку — Шчаслівы гаст",
  "item.minecraft.harness": "Вупраж",
  "item.minecraft.heart_of_the_sea": "Сэрца мора",
  "item.minecraft.heart_pottery_shard": "Ганчарны чарапок «Сэрца»",
  "item.minecraft.heart_pottery_sherd": "Ганчарны чарапок «Сэрца»",
  "item.minecraft.heartbreak_pottery_shard": "Ганчарны чарапок «Разбітае сэрца»",
  "item.minecraft.heartbreak_pottery_sherd": "Ганчарны чарапок «Разбітае сэрца»",
  "item.minecraft.hoglin_spawn_egg": "Яйка выкліку — Гоглін",
  "item.minecraft.honey_bottle": "Пляшка мёду",
  "item.minecraft.honeycomb": "Соты",
  "item.minecraft.hopper_minecart": "Ваганетка з варонкай",
  "item.minecraft.horse_spawn_egg": "Яйка выкліку — Конь",
  "item.minecraft.host_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.host_armor_trim_smithing_template.new": "Арнамент «Гаспадар»",
  "item.minecraft.howl_pottery_shard": "Ганчарны чарапок «Выццё»",
  "item.minecraft.howl_pottery_sherd": "Ганчарны чарапок «Выццё»",
  "item.minecraft.husk_spawn_egg": "Яйка выкліку — Здыхляк",
  "item.minecraft.ink_sac": "Чарнільны мяшок",
  "item.minecraft.iron_axe": "Жалезная сякера",
  "item.minecraft.iron_boots": "Жалезныя боты",
  "item.minecraft.iron_chestplate": "Жалезная кіраса",
  "item.minecraft.iron_golem_spawn_egg": "Яйка выкліку — Жалезны голем",
  "item.minecraft.iron_helmet": "Жалезны шлем",
  "item.minecraft.iron_hoe": "Жалезная матыка",
  "item.minecraft.iron_horse_armor": "Жалезная конская браня",
  "item.minecraft.iron_ingot": "Жалезны злітак",
  "item.minecraft.iron_leggings": "Жалезныя понажы",
  "item.minecraft.iron_nautilus_armor": "Жалезная наўтылусава браня",
  "item.minecraft.iron_nugget": "Кавалак жалеза",
  "item.minecraft.iron_pickaxe": "Жалезная кірка",
  "item.minecraft.iron_shovel": "Жалезная рыдлёўка",
  "item.minecraft.iron_spear": "Жалезная дзіда",
  "item.minecraft.iron_sword": "Жалезны меч",
  "item.minecraft.item_frame": "Рамка",
  "item.minecraft.jungle_boat": "Човен з трапічнай драўніны",
  "item.minecraft.jungle_chest_boat": "Човен з трапічнай драўніны з куфрам",
  "item.minecraft.knowledge_book": "Кніга ведаў",
  "item.minecraft.lapis_lazuli": "Лазурыт",
  "item.minecraft.lava_bucket": "Вядро лавы",
  "item.minecraft.lead": "Павадок",
  "item.minecraft.leather": "Скура",
  "item.minecraft.leather_boots": "Скураныя боты",
  "item.minecraft.leather_chestplate": "Скураная куртка",
  "item.minecraft.leather_helmet": "Скураная шапка",
  "item.minecraft.leather_horse_armor": "Скураная конская браня",
  "item.minecraft.leather_leggings": "Скураныя нагавіцы",
  "item.minecraft.light_blue_bundle": "Блакітны мех",
  "item.minecraft.light_blue_dye": "Блакітны фарбавальнік",
  "item.minecraft.light_blue_harness": "Блакітная вупраж",
  "item.minecraft.light_gray_bundle": "Светла-шэры мех",
  "item.minecraft.light_gray_dye": "Светла-шэры фарбавальнік",
  "item.minecraft.light_gray_harness": "Светла-шэрая вупраж",
  "item.minecraft.lime_bundle": "Лаймавы мех",
  "item.minecraft.lime_dye": "Лаймавы фарбавальнік",
  "item.minecraft.lime_harness": "Лаймавая вупраж",
  "item.minecraft.lingering_potion": "Трывалае зелле",
  "item.minecraft.lingering_potion.effect.awkward": "Нязграбнае трывалае зелле",
  "item.minecraft.lingering_potion.effect.empty": "Трывалае нестваральнае зелле",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Трывалае зелле вогнеўстойлівасці",
  "item.minecraft.lingering_potion.effect.harming": "Трывалае зелле шкоды",
  "item.minecraft.lingering_potion.effect.healing": "Трывалае зелле гаення",
  "item.minecraft.lingering_potion.effect.infested": "Трывалае зелле заражэння",
  "item.minecraft.lingering_potion.effect.invisibility": "Трывалае зелле нябачнасці",
  "item.minecraft.lingering_potion.effect.leaping": "Трывалае зелле скакучасці",
  "item.minecraft.lingering_potion.effect.levitation": "Трывалае зелле левітацыі",
  "item.minecraft.lingering_potion.effect.luck": "Трывалае зелле ўдачы",
  "item.minecraft.lingering_potion.effect.mundane": "Звычайнае трывалае зелле",
  "item.minecraft.lingering_potion.effect.night_vision": "Трывалае зелле начнога зроку",
  "item.minecraft.lingering_potion.effect.oozing": "Трывалае зелле аслізласці",
  "item.minecraft.lingering_potion.effect.poison": "Трывалае атрутнае зелле",
  "item.minecraft.lingering_potion.effect.regeneration": "Трывалае зелле рэгенерацыі",
  "item.minecraft.lingering_potion.effect.slow_falling": "Трывалае зелле павольнага падзення",
  "item.minecraft.lingering_potion.effect.slowness": "Трывалае зелле запаволення",
  "item.minecraft.lingering_potion.effect.strength": "Трывалае зелле моцы",
  "item.minecraft.lingering_potion.effect.swiftness": "Трывалае зелле хуткасці",
  "item.minecraft.lingering_potion.effect.thick": "Густое трывалае зелле",
  "item.minecraft.lingering_potion.effect.turtle_master": "Трывалае зелле чарапашай моцы",
  "item.minecraft.lingering_potion.effect.water": "Трывалая пляшка вады",
  "item.minecraft.lingering_potion.effect.water_breathing": "Трывалае зелле падводнага дыхання",
  "item.minecraft.lingering_potion.effect.weakness": "Трывалае зелле кволасці",
  "item.minecraft.lingering_potion.effect.weaving": "Трывалае зелле пляцення",
  "item.minecraft.lingering_potion.effect.wind_charged": "Трывалае зелле ветранасці",
  "item.minecraft.llama_spawn_egg": "Яйка выкліку — Лама",
  "item.minecraft.lodestone_compass": "Намагнічаны компас",
  "item.minecraft.mace": "Булава",
  "item.minecraft.magenta_bundle": "Пурпурны мех",
  "item.minecraft.magenta_dye": "Пурпурны фарбавальнік",
  "item.minecraft.magenta_harness": "Пурпурная вупраж",
  "item.minecraft.magma_cream": "Згустак магмы",
  "item.minecraft.magma_cube_spawn_egg": "Яйка выкліку — Магмакуб",
  "item.minecraft.mangrove_boat": "Човен з мангравай драўніны",
  "item.minecraft.mangrove_chest_boat": "Човен з мангравай драўніны з куфрам",
  "item.minecraft.map": "Пустая карта",
  "item.minecraft.melon_seeds": "Насенне кавуна",
  "item.minecraft.melon_slice": "Кавалак кавуна",
  "item.minecraft.milk_bucket": "Вядро малака",
  "item.minecraft.minecart": "Ваганетка",
  "item.minecraft.miner_pottery_shard": "Ганчарны чарапок «Шахцёр»",
  "item.minecraft.miner_pottery_sherd": "Ганчарны чарапок «Шахцёр»",
  "item.minecraft.mojang_banner_pattern": "Шаблон сцяга",
  "item.minecraft.mojang_banner_pattern.desc": "Штосьці",
  "item.minecraft.mojang_banner_pattern.new": "Шаблон сцяга «Штосьці»",
  "item.minecraft.mooshroom_spawn_egg": "Яйка выкліку — Муушрум",
  "item.minecraft.mourner_pottery_shard": "Ганчарны чарапок «Смуткоўца»",
  "item.minecraft.mourner_pottery_sherd": "Ганчарны чарапок «Смуткоўца»",
  "item.minecraft.mule_spawn_egg": "Яйка выкліку — Мул",
  "item.minecraft.mushroom_stew": "Тушаныя грыбы",
  "item.minecraft.music_disc_11": "Грампласцінка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Грампласцінка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Грампласцінка",
  "item.minecraft.music_disc_5.desc": "Самуэль Обэрг — 5",
  "item.minecraft.music_disc_blocks": "Грампласцінка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Грампласцінка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Грампласцінка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Грампласцінка",
  "item.minecraft.music_disc_creator.desc": "Лейна Рэйн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Грампласцінка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лейна Рэйн — Creator (Music Box)",
  "item.minecraft.music_disc_far": "Грампласцінка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Грампласцінка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Грампласцінка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Грампласцінка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Грампласцінка",
  "item.minecraft.music_disc_otherside.desc": "Лейна Рэйн — otherside",
  "item.minecraft.music_disc_pigstep": "Грампласцінка",
  "item.minecraft.music_disc_pigstep.desc": "Лейна Рэйн — Pigstep",
  "item.minecraft.music_disc_precipice": "Грампласцінка",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шэроф — Precipice",
  "item.minecraft.music_disc_relic": "Грампласцінка",
  "item.minecraft.music_disc_relic.desc": "Аарон Шэроф — Relic",
  "item.minecraft.music_disc_stal": "Грампласцінка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Грампласцінка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Грампласцінка",
  "item.minecraft.music_disc_tears.desc": "Эймас Родзі — Tears",
  "item.minecraft.music_disc_wait": "Грампласцінка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Грампласцінка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Сырая бараніна",
  "item.minecraft.name_tag": "Бірка",
  "item.minecraft.nautilus_shell": "Ракавіна наўтылуса",
  "item.minecraft.nautilus_spawn_egg": "Яйка выкліку — Наўтылус",
  "item.minecraft.nether_brick": "Нэдарская цагліна",
  "item.minecraft.nether_star": "Зорка Нэдара",
  "item.minecraft.nether_wart": "Нэдарская нарасць",
  "item.minecraft.netherite_axe": "Нэдарытавая сякера",
  "item.minecraft.netherite_boots": "Нэдарытавыя боты",
  "item.minecraft.netherite_chestplate": "Нэдарытавая кіраса",
  "item.minecraft.netherite_helmet": "Нэдарытавы шлем",
  "item.minecraft.netherite_hoe": "Нэдарытавая матыка",
  "item.minecraft.netherite_horse_armor": "Нэдарытавая конская браня",
  "item.minecraft.netherite_ingot": "Нэдарытавы злітак",
  "item.minecraft.netherite_leggings": "Нэдарытавыя понажы",
  "item.minecraft.netherite_nautilus_armor": "Нэдарытавая наўтылусава браня",
  "item.minecraft.netherite_pickaxe": "Нэдарытавая кірка",
  "item.minecraft.netherite_scrap": "Нэдарытавы абломак",
  "item.minecraft.netherite_shovel": "Нэдарытавая рыдлёўка",
  "item.minecraft.netherite_spear": "Нэдарытавая дзіда",
  "item.minecraft.netherite_sword": "Нэдарытавы меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Кавальскі шаблон",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Нэдарытавае паляпшэнне",
  "item.minecraft.oak_boat": "Дубовы човен",
  "item.minecraft.oak_chest_boat": "Дубовы човен з куфрам",
  "item.minecraft.ocelot_spawn_egg": "Яйка выкліку — Ацэлот",
  "item.minecraft.ominous_bottle": "Злавесная пляшка",
  "item.minecraft.ominous_trial_key": "Злавесны ключ выпрабаванняў",
  "item.minecraft.orange_bundle": "Аранжавы мех",
  "item.minecraft.orange_dye": "Аранжавы фарбавальнік",
  "item.minecraft.orange_harness": "Аранжавая вупраж",
  "item.minecraft.painting": "Карціна",
  "item.minecraft.pale_oak_boat": "Човен з бледнага дубу",
  "item.minecraft.pale_oak_chest_boat": "Човен з бледнага дубу з куфрам",
  "item.minecraft.panda_spawn_egg": "Яйка выкліку — Панда",
  "item.minecraft.paper": "Папера",
  "item.minecraft.parched_spawn_egg": "Яйка выкліку — Сухляк",
  "item.minecraft.parrot_spawn_egg": "Яйка выкліку — Папугай",
  "item.minecraft.phantom_membrane": "Мембрана фантома",
  "item.minecraft.phantom_spawn_egg": "Яйка выкліку — Фантом",
  "item.minecraft.pig_spawn_egg": "Яйка выкліку — Свіння",
  "item.minecraft.piglin_banner_pattern": "Шаблон сцяга",
  "item.minecraft.piglin_banner_pattern.desc": "Лыч",
  "item.minecraft.piglin_banner_pattern.new": "Шаблон сцяга «Лыч»",
  "item.minecraft.piglin_brute_spawn_egg": "Яйка выкліку — Брутальны піглін",
  "item.minecraft.piglin_spawn_egg": "Яйка выкліку — Піглін",
  "item.minecraft.pillager_spawn_egg": "Яйка выкліку — Марадзёр",
  "item.minecraft.pink_bundle": "Ружовы мех",
  "item.minecraft.pink_dye": "Ружовы фарбавальнік",
  "item.minecraft.pink_harness": "Ружовая вупраж",
  "item.minecraft.pitcher_plant": "Гладышнік",
  "item.minecraft.pitcher_pod": "Пушачка гладышніка",
  "item.minecraft.plenty_pottery_shard": "Ганчарны чарапок «Багацце»",
  "item.minecraft.plenty_pottery_sherd": "Ганчарны чарапок «Багацце»",
  "item.minecraft.poisonous_potato": "Атрутная бульба",
  "item.minecraft.polar_bear_spawn_egg": "Яйка выкліку — Белы мядзведзь",
  "item.minecraft.popped_chorus_fruit": "Печаны плод хоруса",
  "item.minecraft.porkchop": "Сырая свініна",
  "item.minecraft.potato": "Бульба",
  "item.minecraft.potion": "Зелле",
  "item.minecraft.potion.effect.awkward": "Нязграбнае зелле",
  "item.minecraft.potion.effect.empty": "Нестваральнае зелле",
  "item.minecraft.potion.effect.fire_resistance": "Зелле вогнеўстойлівасці",
  "item.minecraft.potion.effect.harming": "Зелле шкоды",
  "item.minecraft.potion.effect.healing": "Зелле гаення",
  "item.minecraft.potion.effect.infested": "Зелле заражэння",
  "item.minecraft.potion.effect.invisibility": "Зелле нябачнасці",
  "item.minecraft.potion.effect.leaping": "Зелле скакучасці",
  "item.minecraft.potion.effect.levitation": "Зелле левітацыі",
  "item.minecraft.potion.effect.luck": "Зелле ўдачы",
  "item.minecraft.potion.effect.mundane": "Звычайнае зелле",
  "item.minecraft.potion.effect.night_vision": "Зелле начнога зроку",
  "item.minecraft.potion.effect.oozing": "Зелле аслізласці",
  "item.minecraft.potion.effect.poison": "Атрутнае зелле",
  "item.minecraft.potion.effect.regeneration": "Зелле рэгенерацыі",
  "item.minecraft.potion.effect.slow_falling": "Зелле павольнага падзення",
  "item.minecraft.potion.effect.slowness": "Зелле запаволення",
  "item.minecraft.potion.effect.strength": "Зелле моцы",
  "item.minecraft.potion.effect.swiftness": "Зелле хуткасці",
  "item.minecraft.potion.effect.thick": "Густое зелле",
  "item.minecraft.potion.effect.turtle_master": "Зелле чарапашай моцы",
  "item.minecraft.potion.effect.water": "Пляшка вады",
  "item.minecraft.potion.effect.water_breathing": "Зелле падводнага дыхання",
  "item.minecraft.potion.effect.weakness": "Зелле кволасці",
  "item.minecraft.potion.effect.weaving": "Зелле пляцення",
  "item.minecraft.potion.effect.wind_charged": "Зелле ветранасці",
  "item.minecraft.pottery_shard_archer": "Ганчарны чарапок «Лучнік»",
  "item.minecraft.pottery_shard_arms_up": "Ганчарны чарапок «Рукі ўгору»",
  "item.minecraft.pottery_shard_prize": "Ганчарны чарапок «Узнагарода»",
  "item.minecraft.pottery_shard_skull": "Ганчарны чарапок «Чэрап»",
  "item.minecraft.powder_snow_bucket": "Вядро сыпкага снегу",
  "item.minecraft.prismarine_crystals": "Прызмарынавыя крышталі",
  "item.minecraft.prismarine_shard": "Прызмарынавы аскепак",
  "item.minecraft.prize_pottery_shard": "Ганчарны чарапок «Узнагарода»",
  "item.minecraft.prize_pottery_sherd": "Ганчарны чарапок «Узнагарода»",
  "item.minecraft.pufferfish": "Іголкабрух",
  "item.minecraft.pufferfish_bucket": "Вядро з іголкабрухам",
  "item.minecraft.pufferfish_spawn_egg": "Яйка выкліку — Іголкабрух",
  "item.minecraft.pumpkin_pie": "Гарбузовы пірог",
  "item.minecraft.pumpkin_seeds": "Насенне гарбуза",
  "item.minecraft.purple_bundle": "Фіялетавы мех",
  "item.minecraft.purple_dye": "Фіялетавы фарбавальнік",
  "item.minecraft.purple_harness": "Фіялетавая вупраж",
  "item.minecraft.quartz": "Кварц",
  "item.minecraft.rabbit": "Сырая трусяціна",
  "item.minecraft.rabbit_foot": "Лапка труса",
  "item.minecraft.rabbit_hide": "Шкура труса",
  "item.minecraft.rabbit_spawn_egg": "Яйка выкліку — Трус",
  "item.minecraft.rabbit_stew": "Тушаны трус",
  "item.minecraft.raiser_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Арнамент «Гадоўца»",
  "item.minecraft.ravager_spawn_egg": "Яйка выкліку — Спусташальнік",
  "item.minecraft.raw_copper": "Сырая медзь",
  "item.minecraft.raw_gold": "Сырое золата",
  "item.minecraft.raw_iron": "Сырое жалеза",
  "item.minecraft.recovery_compass": "Компас вяртання",
  "item.minecraft.red_bundle": "Чырвоны мех",
  "item.minecraft.red_dye": "Чырвоны фарбавальнік",
  "item.minecraft.red_harness": "Чырвоная вупраж",
  "item.minecraft.redstone": "Рэдстоўнавы пыл",
  "item.minecraft.resin_brick": "Смаляная цагліна",
  "item.minecraft.resin_clump": "Згустак смалы",
  "item.minecraft.rib_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Арнамент «Рабро»",
  "item.minecraft.rotten_flesh": "Гнілое мяса",
  "item.minecraft.saddle": "Сядло",
  "item.minecraft.salmon": "Сыры ласось",
  "item.minecraft.salmon_bucket": "Вядро з ласосем",
  "item.minecraft.salmon_spawn_egg": "Яйка выкліку — Ласось",
  "item.minecraft.scrape_pottery_sherd": "Ганчарны чарапок «Скрабенне»",
  "item.minecraft.scute": "Лускавінка",
  "item.minecraft.sentry_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Арнамент «Варта»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Арнамент «Скульптар»",
  "item.minecraft.sheaf_pottery_shard": "Ганчарны чарапок «Сноп»",
  "item.minecraft.sheaf_pottery_sherd": "Ганчарны чарапок «Сноп»",
  "item.minecraft.shears": "Нажніцы",
  "item.minecraft.sheep_spawn_egg": "Яйка выкліку — Авечка",
  "item.minecraft.shelter_pottery_shard": "Ганчарны чарапок «Прытулак»",
  "item.minecraft.shelter_pottery_sherd": "Ганчарны чарапок «Прытулак»",
  "item.minecraft.shield": "Шчыт",
  "item.minecraft.shield.black": "Чорны шчыт",
  "item.minecraft.shield.blue": "Сіні шчыт",
  "item.minecraft.shield.brown": "Карычневы шчыт",
  "item.minecraft.shield.cyan": "Бірузовы шчыт",
  "item.minecraft.shield.gray": "Шэры шчыт",
  "item.minecraft.shield.green": "Зялёны шчыт",
  "item.minecraft.shield.light_blue": "Блакітны шчыт",
  "item.minecraft.shield.light_gray": "Светла-шэры шчыт",
  "item.minecraft.shield.lime": "Лаймавы шчыт",
  "item.minecraft.shield.magenta": "Пурпурны шчыт",
  "item.minecraft.shield.orange": "Аранжавы шчыт",
  "item.minecraft.shield.pink": "Ружовы шчыт",
  "item.minecraft.shield.purple": "Фіялетавы шчыт",
  "item.minecraft.shield.red": "Чырвоны шчыт",
  "item.minecraft.shield.white": "Белы шчыт",
  "item.minecraft.shield.yellow": "Жоўты шчыт",
  "item.minecraft.shulker_shell": "Панцыр шалкера",
  "item.minecraft.shulker_spawn_egg": "Яйка выкліку — Шалкер",
  "item.minecraft.sign": "Шыльда",
  "item.minecraft.silence_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Арнамент «Цішыня»",
  "item.minecraft.silverfish_spawn_egg": "Яйка выкліку — Лускаўніца",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйка выкліку — Конь-шкілет",
  "item.minecraft.skeleton_spawn_egg": "Яйка выкліку — Шкілет",
  "item.minecraft.skull_banner_pattern": "Шаблон сцяга",
  "item.minecraft.skull_banner_pattern.desc": "Чэрап",
  "item.minecraft.skull_banner_pattern.new": "Шаблон сцяга «Чэрап»",
  "item.minecraft.skull_pottery_shard": "Ганчарны чарапок «Чэрап»",
  "item.minecraft.skull_pottery_sherd": "Ганчарны чарапок «Чэрап»",
  "item.minecraft.slime_ball": "Згустак слізі",
  "item.minecraft.slime_spawn_egg": "Яйка выкліку — Слімак",
  "item.minecraft.smithing_template": "Кавальскі шаблон",
  "item.minecraft.smithing_template.applies_to": "Можна прымяніць да:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Змясціце сюды злітак або крышталь",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Браня",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Змясціце сюды элемент брані",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Зліткі і крышталі",
  "item.minecraft.smithing_template.ingredients": "Інгрэдыенты:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Змясціце сюды нэдарытавы злітак",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Дыяментавыя прылады",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Змясціце сюды дыяментавую браню, зброю ці інструмент",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Нэдарытавы злітак",
  "item.minecraft.smithing_template.upgrade": "Паляпшэнне: ",
  "item.minecraft.sniffer_spawn_egg": "Яйка выкліку — Нюхач",
  "item.minecraft.snort_pottery_shard": "Ганчарны чарапок «Нюхач»",
  "item.minecraft.snort_pottery_sherd": "Ганчарны чарапок «Нюхач»",
  "item.minecraft.snout_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Арнамент «Лыч»",
  "item.minecraft.snow_golem_spawn_egg": "Яйка выкліку — Снежны голем",
  "item.minecraft.snowball": "Снежка",
  "item.minecraft.spectral_arrow": "Спектральная страла",
  "item.minecraft.spider_eye": "Павучынае вока",
  "item.minecraft.spider_spawn_egg": "Яйка выкліку — Павук",
  "item.minecraft.spire_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Арнамент «Вежа»",
  "item.minecraft.splash_potion": "Выбуховае зелле",
  "item.minecraft.splash_potion.effect.awkward": "Нязграбнае выбуховае зелле",
  "item.minecraft.splash_potion.effect.empty": "Выбухное нестваральнае зелле",
  "item.minecraft.splash_potion.effect.fire_resistance": "Выбухное зелле вогнеўстойлівасці",
  "item.minecraft.splash_potion.effect.harming": "Выбухное зелле шкоды",
  "item.minecraft.splash_potion.effect.healing": "Выбухное зелле гаення",
  "item.minecraft.splash_potion.effect.infested": "Выбухное зелле заражэння",
  "item.minecraft.splash_potion.effect.invisibility": "Выбухное зелле нябачнасці",
  "item.minecraft.splash_potion.effect.leaping": "Выбухное зелле скакучасці",
  "item.minecraft.splash_potion.effect.levitation": "Выбухное зелле левітацыі",
  "item.minecraft.splash_potion.effect.luck": "Выбухное зелле ўдачы",
  "item.minecraft.splash_potion.effect.mundane": "Звычайнае выбухное зелле",
  "item.minecraft.splash_potion.effect.night_vision": "Выбухное зелле начнога зроку",
  "item.minecraft.splash_potion.effect.oozing": "Выбухное зелле аслізласці",
  "item.minecraft.splash_potion.effect.poison": "Выбухное атрутнае зелле",
  "item.minecraft.splash_potion.effect.regeneration": "Выбухное зелле рэгенерацыі",
  "item.minecraft.splash_potion.effect.slow_falling": "Выбухное зелле павольнага падзення",
  "item.minecraft.splash_potion.effect.slowness": "Выбухное зелле запаволення",
  "item.minecraft.splash_potion.effect.strength": "Выбухное зелле моцы",
  "item.minecraft.splash_potion.effect.swiftness": "Выбухное зелле хуткасці",
  "item.minecraft.splash_potion.effect.thick": "Густое выбухное зелле",
  "item.minecraft.splash_potion.effect.turtle_master": "Выбухное зелле чарапашай моцы",
  "item.minecraft.splash_potion.effect.water": "Выбухная пляшка вады",
  "item.minecraft.splash_potion.effect.water_breathing": "Выбухное зелле падводнага дыхання",
  "item.minecraft.splash_potion.effect.weakness": "Выбухное зелле кволасці",
  "item.minecraft.splash_potion.effect.weaving": "Выбухное зелле пляцення",
  "item.minecraft.splash_potion.effect.wind_charged": "Выбухное зелле ветранасці",
  "item.minecraft.spruce_boat": "Яловы човен",
  "item.minecraft.spruce_chest_boat": "Яловы човен з куфрам",
  "item.minecraft.spyglass": "Падзорная труба",
  "item.minecraft.squid_spawn_egg": "Яйка выкліку — Спрут",
  "item.minecraft.stick": "Палка",
  "item.minecraft.stone_axe": "Каменная сякера",
  "item.minecraft.stone_hoe": "Каменная матыка",
  "item.minecraft.stone_pickaxe": "Каменная кірка",
  "item.minecraft.stone_shovel": "Каменная рыдлёўка",
  "item.minecraft.stone_spear": "Каменная дзіда",
  "item.minecraft.stone_sword": "Каменны меч",
  "item.minecraft.stray_spawn_egg": "Яйка выкліку — Бадзяга",
  "item.minecraft.strider_spawn_egg": "Яйка выкліку — Лавацуга",
  "item.minecraft.string": "Нітка",
  "item.minecraft.sugar": "Цукар",
  "item.minecraft.suspicious_stew": "Падазронае рагу",
  "item.minecraft.sweet_berries": "Салодкія ягады",
  "item.minecraft.tadpole_bucket": "Вядро з апалонікам",
  "item.minecraft.tadpole_spawn_egg": "Яйка выкліку — Апалонік",
  "item.minecraft.tide_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Арнамент «Хвалі»",
  "item.minecraft.tipped_arrow": "Апрацаваная страла",
  "item.minecraft.tipped_arrow.effect.awkward": "Апрацаваная страла",
  "item.minecraft.tipped_arrow.effect.empty": "Нествараемая апрацаваная страла",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Страла вогнеўстойлівасці",
  "item.minecraft.tipped_arrow.effect.harming": "Страла шкоды",
  "item.minecraft.tipped_arrow.effect.healing": "Гаючая страла",
  "item.minecraft.tipped_arrow.effect.infested": "Страла заражэння",
  "item.minecraft.tipped_arrow.effect.invisibility": "Страла нябачнасці",
  "item.minecraft.tipped_arrow.effect.leaping": "Страла скакучасці",
  "item.minecraft.tipped_arrow.effect.levitation": "Страла левітацыі",
  "item.minecraft.tipped_arrow.effect.luck": "Страла ўдачы",
  "item.minecraft.tipped_arrow.effect.mundane": "Апрацаваная страла",
  "item.minecraft.tipped_arrow.effect.night_vision": "Страла начнога зроку",
  "item.minecraft.tipped_arrow.effect.oozing": "Страла аслізласці",
  "item.minecraft.tipped_arrow.effect.poison": "Атручаная страла",
  "item.minecraft.tipped_arrow.effect.regeneration": "Страла рэгенерацыі",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Страла павольнага падзення",
  "item.minecraft.tipped_arrow.effect.slowness": "Страла запаволення",
  "item.minecraft.tipped_arrow.effect.strength": "Страла моцы",
  "item.minecraft.tipped_arrow.effect.swiftness": "Страла хуткасці",
  "item.minecraft.tipped_arrow.effect.thick": "Апрацаваная страла",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Страла чарапашай моцы",
  "item.minecraft.tipped_arrow.effect.water": "Выбухная страла",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Страла воднага дыхання",
  "item.minecraft.tipped_arrow.effect.weakness": "Страла кволасці",
  "item.minecraft.tipped_arrow.effect.weaving": "Страла пляцення",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Страла ветранасці",
  "item.minecraft.tnt_minecart": "Ваганетка з дынамітам",
  "item.minecraft.torchflower_seeds": "Насенне палымянай лілеі",
  "item.minecraft.totem_of_undying": "Татэм бяссмерця",
  "item.minecraft.trader_llama_spawn_egg": "Яйка выкліку — Лама гандляра",
  "item.minecraft.trial_key": "Ключ выпрабаванняў",
  "item.minecraft.trident": "Трызубец",
  "item.minecraft.tropical_fish": "Трапічная рыба",
  "item.minecraft.tropical_fish_bucket": "Вядро з трапічнай рыбай",
  "item.minecraft.tropical_fish_spawn_egg": "Яйка выкліку — Трапічная рыба",
  "item.minecraft.turtle_helmet": "Панцыр чарапахі",
  "item.minecraft.turtle_scute": "Лускавінка чарапахі",
  "item.minecraft.turtle_spawn_egg": "Яйка выкліку — Чарапаха",
  "item.minecraft.vex_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Арнамент «Шкоднік»",
  "item.minecraft.vex_spawn_egg": "Яйка выкліку — Шкоднік",
  "item.minecraft.villager_spawn_egg": "Яйка выкліку — Вясковец",
  "item.minecraft.vindicator_spawn_egg": "Яйка выкліку — Барацьбіт",
  "item.minecraft.wandering_trader_spawn_egg": "Яйка выкліку — Вандроўны гандляр",
  "item.minecraft.ward_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Арнамент «Вартаўнік»",
  "item.minecraft.warden_spawn_egg": "Яйка выкліку — Вартаўнік",
  "item.minecraft.warped_fungus_on_a_stick": "Скажоны грыб на палачцы",
  "item.minecraft.water_bucket": "Вядро вады",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Арнамент «Першапраходзец»",
  "item.minecraft.wheat": "Пшаніца",
  "item.minecraft.wheat_seeds": "Насенне пшаніцы",
  "item.minecraft.white_bundle": "Белы мех",
  "item.minecraft.white_dye": "Белы фарбавальнік",
  "item.minecraft.white_harness": "Белая вупраж",
  "item.minecraft.wild_armor_trim_smithing_template": "Кавальскі шаблон",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Арнамент «Джунглі»",
  "item.minecraft.wind_charge": "Зарад ветру",
  "item.minecraft.witch_spawn_egg": "Яйка выкліку — Ведзьма",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйка выкліку — Відар-шкілет",
  "item.minecraft.wither_spawn_egg": "Яйка выкліку — Відар",
  "item.minecraft.wolf_armor": "Воўчая браня",
  "item.minecraft.wolf_spawn_egg": "Яйка выкліку — Воўк",
  "item.minecraft.wooden_axe": "Драўляная сякера",
  "item.minecraft.wooden_hoe": "Драўляная матыка",
  "item.minecraft.wooden_pickaxe": "Драўляная кірка",
  "item.minecraft.wooden_shovel": "Драўляная рыдлёўка",
  "item.minecraft.wooden_spear": "Драўляная дзіда",
  "item.minecraft.wooden_sword": "Драўляны меч",
  "item.minecraft.writable_book": "Кніга і пяро",
  "item.minecraft.written_book": "Напісаная кніга",
  "item.minecraft.yellow_bundle": "Жоўты мех",
  "item.minecraft.yellow_dye": "Жоўты фарбавальнік",
  "item.minecraft.yellow_harness": "Жоўтая вупраж",
  "item.minecraft.zoglin_spawn_egg": "Яйка выкліку — Зоглін",
  "item.minecraft.zombie_horse_spawn_egg": "Яйка выкліку — Конь-мярцвяк",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйка выкліку — Наўтылус-мярцвяк",
  "item.minecraft.zombie_spawn_egg": "Яйка прызыву — Мярцвяк",
  "item.minecraft.zombie_villager_spawn_egg": "Яйка выкліку — Мярцвяк-вясковец",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйка выкліку — Мярцвяк-піглін"
}
export const be_by = items; 
